import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import { messages as campaignTrackerMessages } from '../i18n/campaign-tracker-messages';
import { messages } from '../i18n/messages';

import { tagBackgroundColors, tagBorderColors, templateStyles } from './styles';

const CampaignTracker: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={348} height={142} fill="none">
      <rect width={336} height={142} fill={templateStyles['background']} rx={3} />
      <g clipPath="url(#campaignTracker-a)">
        <rect
          width={76}
          height={134.18}
          x={4}
          y={4}
          fill={templateStyles['boardBackground']}
          rx={1.02}
        />
        <rect
          width={23.7}
          height={6.48}
          x={6.86}
          y={8.22}
          fill={tagBackgroundColors['greyLight']}
          rx={0.87}
        />
        <rect
          width={23.7}
          height={6.48}
          x={6.86}
          y={8.22}
          stroke={tagBorderColors['greyLight']}
          strokeWidth={0.3}
          rx={0.87}
        />
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={4.75}
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={8.5} y={13.04}>
            {formatMessage(
              campaignTrackerMessages['campaign-tracker.field-5-select-option-1']
            )}
          </tspan>
        </text>
        <g filter="url(#campaignTracker-b)">
          <rect
            width={70.57}
            height={52.21}
            x={6.71}
            y={18.92}
            fill={templateStyles['background']}
            rx={1.36}
          />
          <text
            xmlSpace="preserve"
            fill={templateStyles['fontColor']}
            fontFamily={templateStyles['fontFamily']}
            fontSize={5.43}
            fontWeight="bold"
            letterSpacing="0em"
            style={{
              whiteSpace: 'pre'
            }}
          >
            <tspan x={9.43} y={28.32}>
              {formatMessage(
                campaignTrackerMessages['campaign-tracker.entry-5-cell-1']
              ).substring(0, 19)}
            </tspan>
            <tspan x={9.43} y={35.1}>
              {formatMessage(
                campaignTrackerMessages['campaign-tracker.entry-5-cell-1']
              ).substring(19)}
            </tspan>
          </text>
          <rect
            width={45.7}
            height={6.48}
            x={9.58}
            y={39.86}
            fill={tagBackgroundColors['yellow']}
            rx={0.87}
          />
          <rect
            width={45.7}
            height={6.48}
            x={9.58}
            y={39.86}
            stroke={tagBorderColors['yellow']}
            strokeWidth={0.3}
            rx={0.87}
          />
          <text
            xmlSpace="preserve"
            fill={templateStyles['fontColor']}
            fontFamily={templateStyles['fontFamily']}
            fontSize={4.75}
            letterSpacing="0em"
            style={{
              whiteSpace: 'pre'
            }}
          >
            <tspan x={10.58} y={44.68}>
              {formatMessage(
                campaignTrackerMessages['campaign-tracker.field-2-select-option-1']
              )}
            </tspan>
          </text>
          <rect
            width={30.71}
            height={8.36}
            x={9.43}
            y={49.21}
            fill={templateStyles['userBackground']}
            rx={1.02}
          />
          <path
            fill={templateStyles['fontColor']}
            d="M11.93 54.96c-.15 0-.28-.02-.39-.06a.82.82 0 0 1-.47-.44c-.05-.1-.07-.21-.08-.34v-.03h.41v.03c.01.08.04.16.08.23s.1.12.17.17c.07.04.17.06.27.06.19 0 .33-.05.43-.16.1-.1.15-.27.15-.47v-2.41h.41v2.42c0 .2-.04.39-.12.54a.8.8 0 0 1-.33.34 1.1 1.1 0 0 1-.53.12Zm2.62-.03a.97.97 0 0 1-.47-.1.7.7 0 0 1-.3-.32 1.2 1.2 0 0 1-.09-.5v-1.62h.4v1.52c0 .22.05.39.14.5.08.1.23.16.43.16a.8.8 0 0 0 .29-.05.57.57 0 0 0 .21-.14c.06-.06.1-.13.13-.22a.93.93 0 0 0 .04-.3V52.4h.4v2.5h-.4v-.38h-.04a.7.7 0 0 1-.16.23.7.7 0 0 1-.25.14c-.1.03-.2.05-.33.05Zm1.96-.04v-3.5h.4v3.5h-.4Zm1.4.87a.93.93 0 0 1-.19-.01v-.33H17.9c.12 0 .2-.02.28-.08a.6.6 0 0 0 .18-.3l.05-.15-.93-2.5h.43l.77 2.3-.16-.25h.2l-.17.25.77-2.3h.42l-.97 2.65c-.07.19-.14.33-.22.44a.62.62 0 0 1-.26.22.94.94 0 0 1-.38.06Zm5.22-.87v-.7H21.5v-.38a95.01 95.01 0 0 1 1.43-2.27h.6v2.28h.48v.37h-.47v.7h-.41Zm-1.2-1.07h1.2v-1.9h-.03a23.27 23.27 0 0 0-.71 1.11 50.3 50.3 0 0 0-.46.76v.03Zm2.47 1.92.2-1.32h.46l-.37 1.32h-.3Zm2.84-.85v-.3l1.13-1.22.34-.38c.08-.1.13-.2.17-.28a.72.72 0 0 0 .04-.26.64.64 0 0 0-.07-.32.56.56 0 0 0-.22-.22.67.67 0 0 0-.34-.09.71.71 0 0 0-.35.09.58.58 0 0 0-.23.23.68.68 0 0 0-.09.34h-.4a1 1 0 0 1 .53-.89c.17-.09.36-.13.57-.13.2 0 .37.04.52.12.16.08.28.2.37.33.1.15.14.3.14.49 0 .13-.02.25-.07.37-.04.12-.12.25-.23.39-.11.14-.27.32-.47.53l-.86.89.1-.2v.2l-.1-.07h1.69v.38h-2.17Zm3.99.07a.98.98 0 0 1-.64-.2c-.17-.15-.3-.35-.4-.61-.1-.27-.14-.58-.14-.94s.04-.67.14-.93.23-.46.4-.6a.98.98 0 0 1 .64-.22c.24 0 .46.07.63.21.18.15.31.35.4.6.1.27.15.58.15.94s-.05.67-.14.94c-.1.26-.23.46-.4.6a.98.98 0 0 1-.64.21Zm0-.36c.16 0 .3-.06.4-.17.12-.11.2-.27.27-.48.06-.2.1-.45.1-.74s-.04-.53-.1-.74c-.06-.2-.15-.36-.26-.47a.56.56 0 0 0-.41-.17c-.16 0-.3.05-.41.17-.12.1-.2.27-.26.47-.06.2-.1.45-.1.74s.04.53.1.74c.06.2.14.37.26.48.11.11.25.17.4.17Zm1.87.29v-.3l1.13-1.22.33-.38c.08-.1.14-.2.17-.28a.72.72 0 0 0 .05-.26.64.64 0 0 0-.08-.32.56.56 0 0 0-.21-.22.67.67 0 0 0-.34-.09.71.71 0 0 0-.35.09.58.58 0 0 0-.24.23.68.68 0 0 0-.08.34h-.4a1 1 0 0 1 .53-.89c.16-.09.35-.13.57-.13.2 0 .37.04.52.12.16.08.28.2.37.33.1.15.14.3.14.49 0 .13-.02.25-.07.37-.04.12-.12.25-.23.39-.11.14-.27.32-.47.53l-.87.89.1-.2v.2l-.1-.07h1.7v.38H33.1Zm3.96.07c-.2 0-.39-.04-.55-.12-.16-.08-.3-.2-.4-.33a1 1 0 0 1-.16-.48V54h.4v.02a.63.63 0 0 0 .36.5c.11.05.23.08.36.08.15 0 .28-.04.39-.1a.7.7 0 0 0 .26-.28c.07-.11.1-.24.1-.4a.78.78 0 0 0-.1-.4.7.7 0 0 0-.26-.26.75.75 0 0 0-.39-.1.9.9 0 0 0-.3.05.72.72 0 0 0-.4.35H36l.18-1.92h1.86v.37h-1.53l-.12 1.13h.04a.69.69 0 0 1 .19-.19.98.98 0 0 1 .53-.16c.2 0 .4.05.55.15.17.1.3.23.39.4.09.17.14.36.14.57 0 .23-.05.43-.15.6-.1.18-.24.31-.41.4-.18.1-.38.15-.6.15Z"
          />
          <g clipPath="url(#campaignTracker-c)">
            <rect
              width={65.15}
              height={6.78}
              x={9.43}
              y={60.28}
              fill={templateStyles['background']}
              rx={1.02}
            />
            <path fill={templateStyles['background']} d="M10.44 61.3h4.75v4.74h-4.75z" />
            <path
              fill={templateStyles['link']}
              d="M12.17 63.57c-.05-.05-.12-.05-.15.01l-.77 1.54a.1.1 0 0 0 0 .09.1.1 0 0 0 .08.04h1.07a.09.09 0 0 0 .08-.05c.23-.48.1-1.2-.31-1.63Zm.56-1.4c-.43.68-.4 1.43-.12 2l.52 1.03a.1.1 0 0 0 .08.05h1.07a.1.1 0 0 0 .08-.13l-1.47-2.95c-.04-.07-.12-.07-.16 0ZM17.73 65.33c-.24 0-.45-.04-.63-.12-.18-.08-.33-.2-.43-.34a.84.84 0 0 1-.16-.5.83.83 0 0 1 .35-.68c.1-.09.23-.14.37-.18a.9.9 0 0 1-.43-.29.7.7 0 0 1-.17-.46c0-.17.05-.32.14-.46.1-.13.23-.23.4-.3.16-.09.35-.12.56-.12.21 0 .4.03.56.11.17.08.3.18.4.31.09.14.13.29.13.45a.7.7 0 0 1-.16.47.88.88 0 0 1-.44.28v.01a.93.93 0 0 1 .63.48.84.84 0 0 1-.06.89c-.1.14-.25.25-.43.33-.19.08-.4.12-.63.12Zm0-.36a1 1 0 0 0 .4-.08.7.7 0 0 0 .29-.22c.06-.1.1-.2.1-.32a.54.54 0 0 0-.1-.33.67.67 0 0 0-.28-.22.98.98 0 0 0-.41-.09c-.16 0-.3.03-.41.09a.69.69 0 0 0-.28.22c-.07.1-.1.2-.1.32 0 .13.03.24.1.33.07.1.16.17.28.22a1 1 0 0 0 .4.08Zm0-1.62c.13 0 .25-.03.35-.07.1-.05.18-.12.24-.2a.5.5 0 0 0 .09-.29.5.5 0 0 0-.09-.29.56.56 0 0 0-.24-.2.83.83 0 0 0-.35-.07.82.82 0 0 0-.36.08.56.56 0 0 0-.24.2.5.5 0 0 0-.08.28c0 .11.03.2.08.3.06.07.14.14.24.19.1.04.22.07.36.07Zm3.7 1.93-.7-2.5h.41l.5 2h.03l.56-2h.38l.56 2h.04l.49-2h.4l-.7 2.5H23l-.57-1.94h-.03l-.56 1.94h-.4Zm3.82.04a.98.98 0 0 1-.43-.09.74.74 0 0 1-.3-.26.7.7 0 0 1-.1-.4c0-.14.03-.27.1-.38a.7.7 0 0 1 .31-.25c.14-.06.3-.1.5-.1l.91-.06v.32l-.86.06a.76.76 0 0 0-.42.12.34.34 0 0 0-.13.29c0 .13.05.23.14.3.1.07.22.1.36.1a.8.8 0 0 0 .37-.08c.1-.06.19-.13.25-.23.06-.09.1-.2.1-.31v-.78c0-.16-.05-.28-.15-.36-.1-.08-.23-.12-.42-.12a.74.74 0 0 0-.37.08.4.4 0 0 0-.19.23h-.4v-.01a.67.67 0 0 1 .16-.34c.09-.1.2-.18.34-.23.14-.06.3-.09.48-.09.2 0 .37.04.51.1a.7.7 0 0 1 .33.3c.07.11.1.26.1.44v1.7h-.4v-.36h-.03a.85.85 0 0 1-.45.36 1 1 0 0 1-.31.05Zm2.05.83a.97.97 0 0 1-.17-.01v-.33h.08l.08.01c.12 0 .21-.03.28-.09a.6.6 0 0 0 .18-.3l.05-.15-.93-2.5h.43l.77 2.3-.16-.25h.2l-.17.26.77-2.31h.43l-.98 2.65c-.07.19-.14.33-.22.44a.62.62 0 0 1-.26.22.94.94 0 0 1-.38.06Zm3.16-.83c-.19 0-.35-.03-.5-.08a.86.86 0 0 1-.34-.24.66.66 0 0 1-.15-.36h.42c.03.1.1.19.2.25s.22.1.38.1c.11 0 .21-.02.3-.05a.51.51 0 0 0 .2-.14.3.3 0 0 0 .08-.2.27.27 0 0 0-.1-.22.79.79 0 0 0-.34-.15l-.39-.1a1.41 1.41 0 0 1-.38-.14.6.6 0 0 1-.22-.22.64.64 0 0 1-.08-.3c0-.15.04-.27.12-.38.09-.11.2-.2.34-.26s.3-.1.47-.1c.18 0 .33.03.47.09.13.05.24.13.32.23.09.1.14.22.16.35h-.4a.4.4 0 0 0-.18-.24.66.66 0 0 0-.37-.09c-.1 0-.19.02-.26.05a.44.44 0 0 0-.19.13.3.3 0 0 0-.06.2c0 .05.01.1.04.15.03.04.08.08.14.11l.24.09.38.09c.24.06.41.14.53.24.11.11.17.25.17.43 0 .16-.04.29-.13.4-.1.11-.21.2-.36.27-.15.06-.32.1-.51.1Zm4.36.04c-.3 0-.57-.08-.79-.22a1.4 1.4 0 0 1-.5-.6 2.23 2.23 0 0 1-.19-.93c0-.37.06-.68.18-.94.12-.26.3-.46.51-.6.22-.15.48-.22.79-.22.23 0 .45.05.64.14.19.1.35.22.47.38.13.17.2.35.24.57h-.42a.92.92 0 0 0-.93-.7c-.22 0-.4.05-.56.16-.16.12-.28.27-.36.48-.09.2-.13.44-.13.72 0 .29.04.53.13.73a.94.94 0 0 0 .92.64c.16 0 .3-.02.42-.07a.88.88 0 0 0 .32-.22c.09-.1.15-.2.18-.33h.43a1.15 1.15 0 0 1-.71.88c-.19.08-.4.13-.64.13Zm2.02-.08v-3.5h.4v3.5h-.4Zm2.2.04c-.23 0-.43-.05-.6-.15-.18-.1-.31-.26-.4-.45-.1-.2-.14-.42-.14-.69 0-.27.04-.5.14-.7.09-.19.22-.34.4-.44.17-.1.37-.16.6-.16.25 0 .45.06.62.16.17.1.3.25.4.44.1.2.14.43.14.7 0 .27-.05.5-.14.69a1.04 1.04 0 0 1-1.01.6Zm0-.36a.7.7 0 0 0 .41-.1c.11-.08.2-.19.25-.33.06-.14.09-.3.09-.5s-.03-.37-.09-.51a.68.68 0 0 0-.25-.32.7.7 0 0 0-.4-.11.7.7 0 0 0-.4.11.69.69 0 0 0-.25.32c-.06.14-.1.3-.1.5v.01c0 .2.04.36.1.5a.7.7 0 0 0 .25.32.7.7 0 0 0 .4.11Zm2.62.36a.97.97 0 0 1-.47-.1.7.7 0 0 1-.3-.32 1.2 1.2 0 0 1-.09-.5v-1.62h.4v1.52c0 .22.05.39.14.5.09.1.23.16.43.16a.8.8 0 0 0 .29-.04.57.57 0 0 0 .21-.14c.06-.07.1-.14.13-.23a.93.93 0 0 0 .04-.3v-1.47h.4v2.5h-.4v-.38h-.03a.7.7 0 0 1-.17.23.7.7 0 0 1-.25.14c-.1.03-.2.05-.33.05Zm2.86 0a.96.96 0 0 1-.91-.6c-.1-.2-.13-.43-.13-.69 0-.27.04-.5.13-.69.08-.19.2-.34.36-.45.16-.1.34-.16.55-.16a.92.92 0 0 1 .6.21.7.7 0 0 1 .18.23h.04v-1.39h.4v3.5h-.4v-.4h-.04a.86.86 0 0 1-.19.24.86.86 0 0 1-.26.15c-.1.03-.21.05-.33.05Zm.1-.36c.15 0 .28-.03.39-.11.1-.08.2-.18.25-.32.06-.14.09-.3.09-.5s-.03-.36-.09-.5a.72.72 0 0 0-.25-.33.67.67 0 0 0-.4-.11.67.67 0 0 0-.39.11c-.1.08-.19.18-.25.32-.05.14-.08.31-.08.5v.01c0 .2.03.36.08.5.06.14.15.25.25.32.11.08.24.11.4.11Zm3.24.32v-2.5h.4v2.5h-.4Zm.2-2.98a.27.27 0 0 1-.2-.09.27.27 0 0 1-.07-.2.27.27 0 0 1 .28-.28c.07 0 .14.04.2.09.05.05.07.12.07.2 0 .07-.02.14-.08.2a.27.27 0 0 1-.2.08Zm1.82 3.02c-.18 0-.34-.03-.49-.08a.86.86 0 0 1-.34-.24.66.66 0 0 1-.15-.36h.41c.04.1.1.19.2.25s.23.1.39.1c.11 0 .21-.02.3-.05a.51.51 0 0 0 .2-.14.3.3 0 0 0 .07-.2.27.27 0 0 0-.1-.22.79.79 0 0 0-.33-.15l-.39-.1a1.41 1.41 0 0 1-.38-.14.6.6 0 0 1-.23-.22.64.64 0 0 1-.07-.3c0-.15.04-.27.12-.38.08-.11.2-.2.34-.26s.3-.1.47-.1c.18 0 .33.03.46.09.14.05.25.13.33.23.08.1.14.22.15.35h-.4a.4.4 0 0 0-.17-.24.66.66 0 0 0-.37-.09c-.1 0-.19.02-.27.05a.44.44 0 0 0-.18.13.3.3 0 0 0-.07.2c0 .05.02.1.05.15.03.04.07.08.13.11l.24.09.39.09c.23.06.4.14.52.24.12.11.18.25.18.43 0 .16-.05.29-.14.4-.08.11-.2.2-.36.27-.15.06-.32.1-.5.1Zm3.86-.02c-.26 0-.45-.06-.56-.16-.12-.1-.17-.27-.17-.51V63.1h-.4v-.33h.4v-.65h.41v.65h.55v.33h-.55v1.42c0 .14.03.25.09.31.05.07.14.1.27.1a1.43 1.43 0 0 0 .19-.01v.34a3.08 3.08 0 0 1-.23.03Zm.83-.02v-2.5h.4v.37h.04a.6.6 0 0 1 .25-.3c.11-.08.25-.12.42-.12a1.32 1.32 0 0 1 .2.02v.4a1.18 1.18 0 0 0-.25-.03.73.73 0 0 0-.34.07.59.59 0 0 0-.23.22.6.6 0 0 0-.08.32v1.55h-.4Zm2.5.04a.98.98 0 0 1-.43-.09.74.74 0 0 1-.3-.26.7.7 0 0 1-.1-.4c0-.14.03-.27.1-.38a.7.7 0 0 1 .31-.25c.14-.06.3-.1.5-.1l.91-.06v.32l-.87.06a.76.76 0 0 0-.41.12.34.34 0 0 0-.13.29c0 .13.04.23.14.3.1.07.22.1.36.1a.8.8 0 0 0 .37-.08c.1-.06.19-.13.25-.23.06-.09.1-.2.1-.31v-.78c0-.16-.06-.28-.15-.36-.1-.08-.23-.12-.42-.12a.74.74 0 0 0-.37.08.4.4 0 0 0-.2.23h-.4v-.01a.67.67 0 0 1 .17-.34c.09-.1.2-.18.34-.23.14-.06.3-.09.47-.09.2 0 .38.04.52.1a.7.7 0 0 1 .32.3c.08.11.11.26.11.44v1.7h-.4v-.36h-.04a.85.85 0 0 1-.44.36 1 1 0 0 1-.31.05Zm1.93-.04v-2.5h.4v.37h.04a.7.7 0 0 1 .28-.3.85.85 0 0 1 .45-.12c.28 0 .5.08.65.24.15.16.22.4.22.69v1.62h-.4v-1.52c0-.23-.05-.4-.14-.5-.1-.11-.24-.17-.44-.17a.67.67 0 0 0-.35.09.59.59 0 0 0-.23.24.84.84 0 0 0-.07.38v1.48H59Zm3.63.04c-.18 0-.35-.03-.49-.08a.86.86 0 0 1-.34-.24.66.66 0 0 1-.15-.36h.41c.03.1.1.19.2.25s.23.1.39.1c.11 0 .2-.02.3-.05a.51.51 0 0 0 .2-.14.3.3 0 0 0 .07-.2.27.27 0 0 0-.1-.22.79.79 0 0 0-.33-.15l-.4-.1a1.41 1.41 0 0 1-.38-.14.6.6 0 0 1-.22-.22.64.64 0 0 1-.07-.3c0-.15.04-.27.12-.38.08-.11.2-.2.33-.26.14-.06.3-.1.48-.1.17 0 .33.03.46.09.14.05.25.13.33.23.08.1.13.22.15.35h-.4a.4.4 0 0 0-.17-.24.66.66 0 0 0-.37-.09c-.1 0-.19.02-.27.05a.44.44 0 0 0-.18.13.3.3 0 0 0-.07.2c0 .05.02.1.05.15.03.04.07.08.13.11l.24.09.39.09c.23.06.4.14.52.24.12.11.17.25.17.43 0 .16-.04.29-.13.4-.09.11-.2.2-.36.27-.15.06-.32.1-.5.1Zm1.8-.04V63.1H64v-.33h.42v-.28c0-.17.02-.3.08-.41.05-.11.14-.2.24-.25.11-.05.25-.08.4-.08a1.32 1.32 0 0 1 .27.02v.33l-.08-.01h-.1c-.15 0-.25.03-.32.1-.06.07-.09.17-.09.31v.27h.57v.33h-.57v2.17h-.4Zm2.48.04c-.24 0-.44-.05-.62-.15-.17-.1-.3-.26-.4-.45-.09-.2-.14-.42-.14-.69 0-.27.05-.5.14-.7.1-.19.23-.34.4-.44.18-.1.38-.16.62-.16.23 0 .44.06.61.16.17.1.3.25.4.44.1.2.14.43.14.7 0 .27-.05.5-.14.69a1.04 1.04 0 0 1-1.01.6Zm0-.36a.7.7 0 0 0 .4-.1.7.7 0 0 0 .25-.33c.06-.14.09-.3.09-.5s-.03-.37-.1-.51a.68.68 0 0 0-.24-.32.7.7 0 0 0-.4-.11.7.7 0 0 0-.4.11.69.69 0 0 0-.26.32c-.05.14-.08.3-.08.5v.01c0 .2.03.36.08.5a.7.7 0 0 0 .26.32.7.7 0 0 0 .4.11Zm1.78.32v-2.5h.4v.37h.04a.6.6 0 0 1 .24-.3c.11-.08.25-.12.42-.12a1.33 1.33 0 0 1 .2.02v.4a1.18 1.18 0 0 0-.24-.03.73.73 0 0 0-.34.07.59.59 0 0 0-.24.22.6.6 0 0 0-.08.32v1.55h-.4Zm2.18.02a.3.3 0 0 1-.21-.09.3.3 0 0 1-.1-.21.3.3 0 0 1 .1-.21.3.3 0 0 1 .2-.1.3.3 0 0 1 .22.1.3.3 0 0 1 .1.2.3.3 0 0 1-.1.22.3.3 0 0 1-.21.09Zm1.2 0a.3.3 0 0 1-.2-.09.3.3 0 0 1-.1-.21c0-.08.03-.16.1-.21a.3.3 0 0 1 .2-.1.3.3 0 0 1 .22.1.3.3 0 0 1 .09.2.3.3 0 0 1-.1.22.3.3 0 0 1-.2.09Zm1.21 0a.3.3 0 0 1-.21-.09.3.3 0 0 1-.1-.21.3.3 0 0 1 .1-.21.3.3 0 0 1 .21-.1.3.3 0 0 1 .21.1.3.3 0 0 1 .1.2.3.3 0 0 1-.1.22.3.3 0 0 1-.2.09Z"
            />
          </g>
          <rect
            width={65.15}
            height={6.78}
            x={9.43}
            y={60.28}
            stroke={templateStyles['border']}
            strokeWidth={0.34}
            rx={1.02}
          />
        </g>
        <g filter="url(#campaignTracker-d)">
          <rect
            width={70.57}
            height={45.21}
            x={6.71}
            y={73.85}
            fill={templateStyles['background']}
            rx={1.36}
          />
          <text
            xmlSpace="preserve"
            fill={templateStyles['fontColor']}
            fontFamily={templateStyles['fontFamily']}
            fontSize={5.43}
            fontWeight="bold"
            letterSpacing="0em"
            style={{
              whiteSpace: 'pre'
            }}
          >
            <tspan x={9.43} y={83.24}>
              {formatMessage(campaignTrackerMessages['campaign-tracker.entry-4-cell-1'])}
            </tspan>
          </text>
          <rect
            width={41.7}
            height={6.48}
            x={9.58}
            y={87.78}
            fill={tagBackgroundColors['teal']}
            rx={0.87}
          />
          <rect
            width={41.7}
            height={6.48}
            x={9.58}
            y={87.78}
            stroke={tagBorderColors['teal']}
            strokeWidth={0.3}
            rx={0.87}
          />
          <text
            xmlSpace="preserve"
            fill={templateStyles['fontColor']}
            fontFamily={templateStyles['fontFamily']}
            fontSize={4.75}
            letterSpacing="0em"
            style={{
              whiteSpace: 'pre'
            }}
          >
            <tspan x={11} y={92.6}>
              {formatMessage(
                campaignTrackerMessages['campaign-tracker.field-2-select-option-3']
              )}
            </tspan>
          </text>
          <rect
            width={32.71}
            height={8.36}
            x={9.43}
            y={97.13}
            fill={templateStyles['userBackground']}
            rx={1.02}
          />
          <path
            fill={templateStyles['fontColor']}
            d="M11.93 102.88c-.15 0-.28-.02-.39-.06a.82.82 0 0 1-.47-.44c-.05-.1-.07-.21-.08-.33V102h.41v.03c.01.08.04.16.08.23s.1.12.17.17c.07.04.17.06.27.06.19 0 .33-.05.43-.16.1-.1.15-.27.15-.47v-2.41h.41v2.42c0 .2-.04.39-.12.54a.81.81 0 0 1-.33.34 1.1 1.1 0 0 1-.53.12Zm2.47-.03a.98.98 0 0 1-.43-.1.73.73 0 0 1-.3-.25.7.7 0 0 1-.1-.4c0-.15.03-.27.1-.38a.7.7 0 0 1 .31-.25c.14-.06.3-.1.5-.1l.92-.06v.32l-.87.06a.76.76 0 0 0-.42.12.34.34 0 0 0-.13.28c0 .13.05.23.14.3.1.07.22.1.36.1a.8.8 0 0 0 .37-.07c.1-.06.2-.13.25-.23.06-.1.1-.2.1-.32v-.78c0-.15-.05-.27-.15-.35-.09-.08-.23-.12-.42-.12a.75.75 0 0 0-.37.08.39.39 0 0 0-.19.22v.01h-.4v-.01a.67.67 0 0 1 .16-.34c.09-.1.2-.18.34-.23.14-.06.3-.09.48-.09.2 0 .37.03.51.1.15.07.25.16.33.29.07.12.1.27.1.44v1.72h-.4v-.37h-.03a.85.85 0 0 1-.45.36 1 1 0 0 1-.3.05Zm1.94-.04v-2.5h.4v.37h.04a.7.7 0 0 1 .27-.3.85.85 0 0 1 .45-.12c.29 0 .5.08.65.24.15.16.23.39.23.69v1.62h-.4v-1.53c0-.22-.05-.39-.15-.5-.1-.1-.24-.16-.44-.16a.66.66 0 0 0-.35.08.58.58 0 0 0-.22.25.84.84 0 0 0-.08.38v1.48h-.4Zm4.1 0v-.3l1.13-1.22c.15-.15.26-.28.34-.38.08-.1.13-.2.17-.27a.73.73 0 0 0 .05-.27.64.64 0 0 0-.08-.32.56.56 0 0 0-.22-.22.67.67 0 0 0-.34-.09.71.71 0 0 0-.35.09.58.58 0 0 0-.23.23.68.68 0 0 0-.09.34h-.4a1 1 0 0 1 .53-.89c.17-.09.36-.13.57-.13.2 0 .37.04.53.12.15.08.28.2.36.33.1.15.14.3.14.49 0 .13-.02.25-.07.37-.04.12-.12.25-.23.39-.1.14-.27.32-.47.53l-.86.89.1-.2v.2l-.1-.07h1.69v.38h-2.17Zm4.05.07a1.12 1.12 0 0 1-.86-.37c-.12-.13-.22-.3-.29-.52-.07-.21-.1-.48-.1-.8 0-.38.04-.7.14-.97.1-.28.25-.48.44-.62.2-.15.43-.22.7-.22.19 0 .35.04.5.1a1.01 1.01 0 0 1 .59.72v.03h-.41l-.01-.02a.68.68 0 0 0-.68-.46.7.7 0 0 0-.49.18c-.13.12-.22.28-.28.47a2.5 2.5 0 0 0-.11.7v.07l.1.56a.8.8 0 0 0 .37.68c.12.07.25.1.39.1s.26-.03.38-.1a.77.77 0 0 0 .37-.67.79.79 0 0 0-.1-.4.69.69 0 0 0-.26-.27.74.74 0 0 0-.39-.1.78.78 0 0 0-.39.1.73.73 0 0 0-.37.66h-.14v-.6h.08a.93.93 0 0 1 .49-.44c.12-.06.25-.08.4-.08.21 0 .4.05.57.14.16.1.3.23.39.4.1.17.14.36.14.58a1.15 1.15 0 0 1-.57 1c-.17.1-.37.15-.6.15Zm1.58.78.2-1.32h.46l-.36 1.32h-.3Zm2.84-.85v-.3l1.14-1.22.33-.38c.08-.1.14-.2.17-.27a.73.73 0 0 0 .05-.27.64.64 0 0 0-.08-.32.56.56 0 0 0-.22-.22.67.67 0 0 0-.34-.09.71.71 0 0 0-.35.09.58.58 0 0 0-.23.23.68.68 0 0 0-.08.34h-.4a1 1 0 0 1 .52-.89c.17-.09.36-.13.57-.13.2 0 .37.04.53.12.16.08.28.2.37.33a1.01 1.01 0 0 1 .07.85c-.05.13-.12.26-.23.4-.12.14-.27.32-.48.53l-.86.89.1-.2v.2l-.1-.07h1.69v.38h-2.17Zm4 .07a.98.98 0 0 1-.64-.2c-.18-.15-.31-.35-.4-.61-.1-.27-.15-.58-.15-.94s.05-.67.14-.93c.1-.26.23-.46.4-.6a.98.98 0 0 1 .64-.22c.25 0 .46.07.64.21.17.15.3.35.4.6.1.27.15.58.15.94s-.05.67-.15.94c-.1.26-.23.46-.4.6a.98.98 0 0 1-.64.21Zm0-.36c.15 0 .29-.06.4-.17.12-.11.2-.27.26-.48.06-.2.1-.45.1-.74s-.04-.53-.1-.74c-.06-.2-.14-.36-.26-.47a.56.56 0 0 0-.41-.17c-.16 0-.3.05-.41.17-.11.1-.2.27-.26.47-.06.2-.09.45-.09.74s.03.53.09.74c.06.2.15.37.26.48.11.11.25.17.41.17Zm1.86.29v-.3l1.13-1.22c.15-.15.26-.28.34-.38.08-.1.13-.2.17-.27a.73.73 0 0 0 .05-.27.64.64 0 0 0-.08-.32.56.56 0 0 0-.22-.22.67.67 0 0 0-.34-.09.71.71 0 0 0-.35.09.58.58 0 0 0-.23.23.68.68 0 0 0-.09.34h-.4a1 1 0 0 1 .53-.89c.17-.09.36-.13.57-.13.2 0 .37.04.53.12.15.08.28.2.36.33.1.15.14.3.14.49 0 .13-.02.25-.07.37-.04.12-.12.25-.23.39-.1.14-.27.32-.47.53l-.86.89.1-.2v.2l-.1-.07h1.69v.38h-2.17Zm4.05.07a1.12 1.12 0 0 1-.86-.37c-.12-.13-.22-.3-.29-.52-.07-.21-.1-.48-.1-.8 0-.38.04-.7.14-.97.1-.28.25-.48.44-.62.2-.15.43-.22.7-.22.19 0 .35.04.5.1a1.01 1.01 0 0 1 .59.72v.03h-.41l-.01-.02a.68.68 0 0 0-.68-.46.7.7 0 0 0-.49.18c-.13.12-.22.28-.28.47a2.5 2.5 0 0 0-.11.7v.07l.1.56a.8.8 0 0 0 .37.68c.12.07.24.1.39.1.14 0 .26-.03.38-.1a.77.77 0 0 0 .37-.67.79.79 0 0 0-.1-.4.69.69 0 0 0-.26-.27.74.74 0 0 0-.39-.1.78.78 0 0 0-.39.1.73.73 0 0 0-.37.66h-.14v-.6H38a.93.93 0 0 1 .49-.44c.12-.06.25-.08.4-.08.21 0 .4.05.57.14.16.1.3.23.39.4.1.17.14.36.14.58a1.15 1.15 0 0 1-.57 1c-.17.1-.37.15-.6.15Z"
          />
          <g clipPath="url(#campaignTracker-e)">
            <rect
              width={65.15}
              height={6.78}
              x={9.43}
              y={108.2}
              fill={templateStyles['background']}
              rx={1.02}
            />
            <g clipPath="url(#campaignTracker-f)">
              <path
                fill={templateStyles['background']}
                d="M10.44 109.22h4.75v4.75h-4.75z"
              />
              <path
                fill={templateStyles['link']}
                d="M12.17 111.49c-.05-.05-.12-.05-.15.01l-.77 1.54a.09.09 0 0 0 0 .09l.03.03.05.01h1.07a.1.1 0 0 0 .05-.01l.03-.04c.23-.48.1-1.2-.31-1.63Zm.56-1.4c-.43.68-.4 1.43-.12 2l.52 1.03a.1.1 0 0 0 .08.05h1.12l.03-.04.01-.04a.1.1 0 0 0 0-.05l-1.48-2.95c-.04-.07-.12-.07-.16 0Z"
              />
            </g>
            <path
              fill={templateStyles['link']}
              d="M16.85 113.2v-.37h1.03c.25 0 .44-.05.57-.15.13-.1.2-.25.2-.44a.55.55 0 0 0-.1-.33.54.54 0 0 0-.26-.2 1.32 1.32 0 0 0-.45-.06h-1v-.36h.88c.26 0 .45-.04.57-.13.13-.09.2-.22.2-.4 0-.17-.06-.3-.18-.4a.73.73 0 0 0-.48-.14h-.98v-.37h1.07c.2 0 .38.04.53.1a.77.77 0 0 1 .46.73.77.77 0 0 1-.29.58.65.65 0 0 1-.29.15v.03c.15.02.29.07.4.14.1.07.2.17.25.28.07.12.1.25.1.4a.9.9 0 0 1-.14.5.87.87 0 0 1-.39.33c-.17.07-.37.1-.6.1h-1.1Zm-.21 0v-3.35h.42v3.35h-.42Zm3.07 0v-2.5h.4v.37h.04a.59.59 0 0 1 .24-.3.85.85 0 0 1 .54-.1h.09v.4a1.08 1.08 0 0 0-.25-.03.73.73 0 0 0-.34.07.59.59 0 0 0-.23.22.6.6 0 0 0-.09.32v1.55h-.4Zm2.5.04a.98.98 0 0 1-.43-.09.73.73 0 0 1-.3-.26.7.7 0 0 1-.11-.4c0-.14.03-.27.1-.38a.7.7 0 0 1 .32-.25c.13-.06.3-.1.49-.1l.92-.06v.32l-.87.06a.76.76 0 0 0-.42.12.35.35 0 0 0-.13.29c0 .13.05.23.14.3.1.07.22.1.37.1a.8.8 0 0 0 .36-.08c.11-.06.2-.13.25-.23.07-.09.1-.2.1-.31v-.78c0-.16-.05-.28-.15-.36-.09-.08-.23-.12-.42-.12a.75.75 0 0 0-.36.08.4.4 0 0 0-.2.23h-.4v-.01a.67.67 0 0 1 .16-.34c.1-.1.2-.18.34-.23.14-.06.3-.09.48-.09.2 0 .38.04.52.1.14.07.25.17.32.3.07.12.11.26.11.44v1.7H23v-.36h-.04a.85.85 0 0 1-.45.36c-.1.04-.2.05-.3.05Zm1.93-.04v-2.5h.4v.37h.04a.71.71 0 0 1 .27-.3.85.85 0 0 1 .46-.12c.28 0 .5.08.64.24.15.16.23.4.23.69v1.62h-.4v-1.52c0-.23-.05-.4-.15-.5-.1-.11-.24-.17-.44-.17a.66.66 0 0 0-.34.09.58.58 0 0 0-.23.24.84.84 0 0 0-.08.38v1.48h-.4Zm3.7.04a.96.96 0 0 1-.93-.6c-.08-.2-.13-.43-.13-.69 0-.27.05-.5.13-.69.1-.19.21-.34.37-.45.16-.1.34-.16.55-.16a.93.93 0 0 1 .6.21.7.7 0 0 1 .18.23h.04v-1.39h.4v3.5h-.4v-.4h-.04a.86.86 0 0 1-.45.39c-.1.03-.21.05-.33.05Zm.09-.36c.15 0 .28-.03.39-.1.1-.09.2-.2.25-.33.06-.14.09-.3.09-.5s-.03-.36-.09-.5a.72.72 0 0 0-.25-.33.68.68 0 0 0-.4-.1.68.68 0 0 0-.39.1c-.1.08-.19.19-.25.32-.05.14-.08.31-.08.5v.01c0 .2.03.36.08.5.06.14.15.25.25.32.11.08.24.11.4.11Zm1.9.32v-2.5h.41v2.5h-.4Zm.21-2.98a.27.27 0 0 1-.2-.09.27.27 0 0 1-.08-.2.27.27 0 0 1 .28-.28c.08 0 .14.04.2.09.05.05.08.12.08.2 0 .07-.03.14-.08.2a.27.27 0 0 1-.2.08Zm.96 2.98v-2.5h.4v.37h.04a.71.71 0 0 1 .27-.3.85.85 0 0 1 .46-.12c.28 0 .5.08.65.24.15.16.22.4.22.69v1.62h-.4v-1.52c0-.23-.05-.4-.14-.5-.1-.11-.25-.17-.44-.17a.66.66 0 0 0-.35.09.58.58 0 0 0-.23.24.84.84 0 0 0-.08.38v1.48H31Zm3.8.88c-.2 0-.37-.03-.52-.09a.87.87 0 0 1-.36-.24.7.7 0 0 1-.17-.35h.42c.03.1.1.17.2.23.11.06.25.1.43.1a.8.8 0 0 0 .53-.16c.12-.1.19-.24.19-.43v-.5h-.04a.84.84 0 0 1-.46.38c-.1.03-.2.05-.32.05a1 1 0 0 1-.56-.16c-.16-.1-.28-.24-.36-.42a1.45 1.45 0 0 1-.13-.62c0-.24.04-.45.13-.63.08-.18.2-.32.36-.43a1 1 0 0 1 .57-.16c.11 0 .22.02.32.06a.88.88 0 0 1 .45.4h.03v-.41h.4v2.46c0 .19-.04.35-.13.49a.86.86 0 0 1-.39.31c-.16.08-.36.12-.59.12Zm-.02-1.37c.16 0 .3-.03.4-.1a.7.7 0 0 0 .26-.3c.06-.13.09-.28.09-.44 0-.17-.03-.32-.1-.45a.7.7 0 0 0-.25-.3.7.7 0 0 0-.4-.1.69.69 0 0 0-.39.1.7.7 0 0 0-.25.3 1.1 1.1 0 0 0-.08.44c0 .17.03.32.08.45a.7.7 0 0 0 .25.3c.1.06.24.1.4.1Zm4.04.49v-2.89h-.04l-.85.62v-.44l.9-.64h.4v3.35h-.41Zm2.5.08a.98.98 0 0 1-.63-.22c-.18-.14-.31-.34-.4-.6-.1-.27-.15-.58-.15-.93 0-.37.05-.68.14-.94.1-.26.23-.46.4-.6a.98.98 0 0 1 .64-.22c.25 0 .46.07.64.22.18.14.31.34.4.6.1.26.15.57.15.93 0 .36-.05.67-.15.94-.09.26-.22.46-.4.6a.98.98 0 0 1-.64.22Zm0-.37c.16 0 .3-.05.41-.17.12-.11.2-.27.27-.48.06-.2.09-.45.09-.73 0-.3-.03-.54-.1-.74-.05-.21-.14-.37-.26-.48a.56.56 0 0 0-.4-.17c-.17 0-.3.05-.42.17-.11.11-.2.27-.26.48-.06.2-.09.45-.09.73 0 .29.03.54.1.74.05.21.14.37.25.48.12.12.25.17.41.17Zm2.7.29v-2.89h-.04l-.85.62v-.44l.89-.64h.41v3.35h-.42Zm2.88 0v-2.17h-.41v-.33h.41v-.28c0-.17.03-.3.08-.41.06-.11.14-.2.25-.25.1-.05.24-.08.4-.08a1.22 1.22 0 0 1 .27.02v.33l-.09-.01h-.1c-.14 0-.25.03-.31.1s-.1.17-.1.31v.27h.57v.33h-.56v2.17h-.4Zm2.48.04c-.24 0-.44-.05-.61-.15-.17-.1-.3-.26-.4-.45-.1-.2-.14-.42-.14-.69 0-.27.05-.5.14-.7a1.04 1.04 0 0 1 1.01-.6c.24 0 .44.05.62.16.17.1.3.25.4.44.09.2.13.43.13.7 0 .27-.04.5-.14.69a1.04 1.04 0 0 1-1 .6Zm0-.36a.7.7 0 0 0 .4-.1.7.7 0 0 0 .25-.33c.06-.14.1-.3.1-.5s-.04-.37-.1-.51a.68.68 0 0 0-.25-.32.7.7 0 0 0-.4-.1.7.7 0 0 0-.4.1.7.7 0 0 0-.25.32c-.06.14-.09.3-.09.5v.01c0 .2.03.36.09.5a.7.7 0 0 0 .25.32.7.7 0 0 0 .4.11Zm1.78.32v-2.5h.4v.37h.04a.59.59 0 0 1 .24-.3.85.85 0 0 1 .54-.1h.09v.4a1.08 1.08 0 0 0-.25-.03.73.73 0 0 0-.34.07.59.59 0 0 0-.23.22.6.6 0 0 0-.09.32v1.55h-.4Zm3.2 0v-3.35h.48l1.15 2.8h.03l1.15-2.8h.48v3.35h-.39v-2.56h-.2l.47-.7-1.35 3.26h-.35l-1.35-3.26.47.7h-.2v2.56h-.4Zm4.78.04a.98.98 0 0 1-.43-.09.73.73 0 0 1-.3-.26.7.7 0 0 1-.1-.4c0-.14.03-.27.1-.38a.7.7 0 0 1 .31-.25c.14-.06.3-.1.5-.1l.92-.06v.32l-.87.06a.76.76 0 0 0-.42.12.35.35 0 0 0-.13.29c0 .13.05.23.14.3.1.07.22.1.36.1a.8.8 0 0 0 .37-.08c.1-.06.2-.13.25-.23.06-.09.1-.2.1-.31v-.78c0-.16-.05-.28-.15-.36-.09-.08-.23-.12-.42-.12a.75.75 0 0 0-.37.08.4.4 0 0 0-.19.23h-.4v-.01a.67.67 0 0 1 .16-.34c.09-.1.2-.18.34-.23.14-.06.3-.09.48-.09.2 0 .37.04.51.1.15.07.25.17.33.3.07.12.1.26.1.44v1.7h-.4v-.36h-.03a.85.85 0 0 1-.45.36c-.1.04-.2.05-.3.05Zm1.93-.04v-2.5h.4v.37h.05a.59.59 0 0 1 .24-.3c.11-.08.25-.12.42-.12l.12.01.09.01v.4a1.08 1.08 0 0 0-.25-.03.73.73 0 0 0-.34.07.59.59 0 0 0-.24.22.6.6 0 0 0-.08.32v1.55h-.4Zm1.84 0v-3.5h.4v3.5h-.4Zm1.57 0-.98-1.23.3-.25L65 113.2h-.5Zm-1.22-.9-.02-.51h.1l1.09-1.1h.49l-1.19 1.15-.1.1-.37.36Zm3.1.94a1.05 1.05 0 0 1-1-.6c-.1-.2-.14-.42-.14-.68 0-.26.05-.49.14-.68.09-.2.22-.35.39-.46.17-.11.37-.17.6-.17.22 0 .41.06.58.16a1 1 0 0 1 .37.44c.09.19.13.4.13.66v.15h-2v-.32h1.8l-.2.3v-.16c0-.2-.03-.36-.1-.49a.62.62 0 0 0-.6-.38.67.67 0 0 0-.35.1.67.67 0 0 0-.25.3c-.07.12-.1.28-.1.47v.16c0 .17.03.33.1.45a.67.67 0 0 0 .65.4c.1 0 .2-.02.29-.05a.65.65 0 0 0 .2-.12c.06-.05.1-.1.12-.15v-.02h.41v.02a.76.76 0 0 1-.12.25.93.93 0 0 1-.2.21 1.1 1.1 0 0 1-.32.16c-.11.03-.25.05-.4.05Zm2.59-.02c-.26 0-.45-.06-.56-.16-.12-.1-.17-.27-.17-.51v-1.52h-.4v-.33h.4v-.65h.41v.65h.55v.33h-.55v1.42c0 .14.03.25.09.31.05.07.15.1.28.1h.09l.1-.01v.34l-.12.02h-.12Zm1.16 0a.3.3 0 0 1-.21-.09.3.3 0 0 1-.09-.21.3.3 0 0 1 .09-.21.3.3 0 0 1 .21-.1c.09 0 .16.04.22.1a.3.3 0 0 1 .08.2.3.3 0 0 1-.08.22.3.3 0 0 1-.22.1Zm1.2 0a.3.3 0 0 1-.2-.09.3.3 0 0 1-.1-.21.3.3 0 0 1 .1-.21.3.3 0 0 1 .2-.1c.1 0 .16.04.22.1a.3.3 0 0 1 .1.2.3.3 0 0 1-.1.22.29.29 0 0 1-.21.1Zm1.22 0a.3.3 0 0 1-.22-.09.3.3 0 0 1-.09-.21.3.3 0 0 1 .1-.21.3.3 0 0 1 .2-.1c.09 0 .16.04.22.1a.3.3 0 0 1 .09.2.3.3 0 0 1-.1.22.3.3 0 0 1-.2.1Z"
            />
          </g>
          <rect
            width={65.15}
            height={6.78}
            x={9.43}
            y={108.2}
            stroke={templateStyles['border']}
            strokeWidth={0.34}
            rx={1.02}
          />
        </g>
        <path
          fill={templateStyles['icon']}
          fillRule="evenodd"
          d="M29.42 130.23v2.12h.51v-2.12h2.12v-.51h-2.12v-2.12h-.5v2.12H27.3v.5h2.12Z"
          clipRule="evenodd"
        />
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={4.75}
          fontWeight={510}
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={34.03} y={131.55}>
            {formatMessage(messages['templates-preview.add-entry'])}
          </tspan>
        </text>
      </g>
      <rect
        width={76}
        height={133}
        x={83}
        y={4}
        fill={templateStyles['boardBackground']}
        rx={1.02}
      />
      <rect
        width={29.7}
        height={6.48}
        x={85.86}
        y={8.22}
        fill={tagBackgroundColors['blueLight']}
        rx={0.87}
      />
      <rect
        width={29.7}
        height={6.48}
        x={85.86}
        y={8.22}
        stroke={tagBorderColors['blueLight']}
        strokeWidth={0.3}
        rx={0.87}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontFamily']}
        fontSize={4.75}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={87.11} y={13.04}>
          {formatMessage(
            campaignTrackerMessages['campaign-tracker.field-5-select-option-2']
          )}
        </tspan>
      </text>
      <g filter="url(#campaignTracker-g)">
        <rect
          width={70.57}
          height={45.21}
          x={85.71}
          y={18.92}
          fill={templateStyles['background']}
          rx={1.36}
        />
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={5.43}
          fontWeight="bold"
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={88.43} y={28.32}>
            {formatMessage(campaignTrackerMessages['campaign-tracker.entry-1-cell-5'])}
          </tspan>
        </text>
        <rect
          width={44.7}
          height={6.48}
          x={88.58}
          y={32.86}
          fill={tagBackgroundColors['orange']}
          rx={0.87}
        />
        <rect
          width={44.7}
          height={6.48}
          x={88.58}
          y={32.86}
          stroke={tagBorderColors['orange']}
          strokeWidth={0.3}
          rx={0.87}
        />
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={4.75}
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={89.74} y={37.68}>
            {formatMessage(
              campaignTrackerMessages['campaign-tracker.field-2-select-option-2']
            )}
          </tspan>
        </text>
        <rect
          width={31.71}
          height={8.36}
          x={88.43}
          y={42.21}
          fill={templateStyles['userBackground']}
          rx={1.02}
        />
        <path
          fill={templateStyles['fontColor']}
          d="M91.62 47.96c-.32 0-.6-.07-.83-.2a1.4 1.4 0 0 1-.53-.62 2.18 2.18 0 0 1-.18-.93c0-.36.06-.67.19-.93a1.41 1.41 0 0 1 1.35-.82 1.39 1.39 0 0 1 1.35.82c.12.26.18.57.18.93 0 .36-.06.67-.18.93a1.4 1.4 0 0 1-1.35.82Zm0-.38c.22 0 .42-.06.59-.17.16-.11.29-.27.38-.48.09-.2.13-.44.13-.72 0-.28-.04-.52-.13-.72-.09-.2-.22-.37-.38-.48a1.03 1.03 0 0 0-.6-.16c-.22 0-.42.05-.58.16-.17.11-.3.27-.39.48-.09.2-.13.44-.13.72 0 .28.04.52.13.72.09.2.21.37.38.48.17.11.36.17.6.17Zm3.23.35a1.06 1.06 0 0 1-1-.61c-.1-.2-.15-.43-.15-.7 0-.26.04-.48.14-.67a1.05 1.05 0 0 1 1-.6c.2 0 .38.03.53.1a.93.93 0 0 1 .52.69v.01h-.4a.57.57 0 0 0-.21-.32.68.68 0 0 0-.44-.13.67.67 0 0 0-.64.43c-.06.14-.09.3-.09.5 0 .19.03.36.1.5a.66.66 0 0 0 .64.44c.16 0 .3-.03.4-.1a.6.6 0 0 0 .24-.32v-.02h.4v.02c-.04.15-.1.29-.19.4-.08.12-.2.21-.34.28-.14.07-.31.1-.51.1Zm2.57-.03c-.26 0-.45-.05-.56-.15-.12-.1-.18-.28-.18-.51v-1.52h-.39v-.33h.4v-.65h.41v.65h.55v.33h-.55v1.41c0 .15.03.26.09.32.05.06.14.1.27.1a1.44 1.44 0 0 0 .19-.01v.34a3.08 3.08 0 0 1-.23.02Zm2.98-.01V45h-.03l-.85.62v-.44l.89-.64h.41v3.35h-.42Zm2.53.05c-.23 0-.43-.04-.6-.12a.93.93 0 0 1-.58-.8V47h.4v.02c0 .11.04.2.11.3a.7.7 0 0 0 .27.19c.12.05.25.07.4.07a.9.9 0 0 0 .38-.08c.11-.05.2-.12.26-.2.06-.1.1-.2.1-.32 0-.21-.08-.37-.21-.48a.85.85 0 0 0-.56-.17h-.42v-.35h.4a.8.8 0 0 0 .36-.07.6.6 0 0 0 .23-.2.54.54 0 0 0 .09-.3v-.01a.57.57 0 0 0-.07-.3.48.48 0 0 0-.22-.19.83.83 0 0 0-.35-.06.88.88 0 0 0-.35.06.57.57 0 0 0-.36.48v.03h-.4v-.03a.98.98 0 0 1 .17-.48c.1-.13.23-.24.39-.31.16-.08.34-.12.55-.12.22 0 .4.04.56.11.16.08.28.18.37.3.09.14.13.29.13.46a.73.73 0 0 1-.34.63c-.1.07-.23.13-.37.15v.01c.24.02.44.1.6.25.14.15.22.34.22.57 0 .2-.05.36-.15.5-.1.15-.24.27-.41.36-.18.08-.38.12-.6.12Zm1.57.8.2-1.32h.47l-.37 1.32h-.3Zm2.85-.85v-.3l1.13-1.22.33-.38c.08-.1.14-.2.17-.28a.73.73 0 0 0 .05-.26.64.64 0 0 0-.07-.32.57.57 0 0 0-.22-.22.67.67 0 0 0-.34-.09.71.71 0 0 0-.35.09.58.58 0 0 0-.23.23.68.68 0 0 0-.09.34h-.4a.98.98 0 0 1 .53-.89c.16-.09.35-.13.57-.13.2 0 .37.04.52.12.16.08.28.2.37.33.1.15.14.3.14.49 0 .13-.02.25-.07.37-.04.12-.12.25-.23.39a7 7 0 0 1-.47.53l-.87.89.1-.2v.2l-.1-.07h1.7v.38h-2.17Zm3.98.07a.98.98 0 0 1-.63-.2c-.17-.15-.31-.35-.4-.61-.1-.27-.15-.58-.15-.94s.05-.67.15-.93c.09-.26.23-.46.4-.6a.98.98 0 0 1 .63-.22c.25 0 .46.07.64.21.18.15.31.35.4.6.1.27.15.58.15.94s-.05.67-.14.94c-.1.26-.23.46-.41.6a.98.98 0 0 1-.64.21Zm0-.36c.17 0 .3-.06.42-.17.11-.11.2-.27.26-.48.06-.2.09-.45.09-.74s-.03-.53-.1-.74c-.05-.2-.14-.36-.25-.47a.56.56 0 0 0-.42-.17c-.15 0-.3.05-.4.17-.12.1-.2.27-.27.47-.06.2-.09.45-.09.74s.03.53.1.74c.05.2.14.37.25.48.12.11.26.17.41.17Zm1.88.29v-.3l1.13-1.22.33-.38c.08-.1.14-.2.17-.28a.73.73 0 0 0 .05-.26.64.64 0 0 0-.08-.32.57.57 0 0 0-.22-.22.67.67 0 0 0-.33-.09.71.71 0 0 0-.35.09.58.58 0 0 0-.24.23.68.68 0 0 0-.08.34h-.4a.99.99 0 0 1 .53-.89c.16-.09.35-.13.56-.13.2 0 .37.04.53.12.16.08.28.2.37.33.09.15.14.3.14.49 0 .13-.03.25-.07.37-.04.12-.12.25-.23.39-.11.14-.27.32-.47.53l-.87.89.1-.2v.2l-.1-.07h1.7v.38h-2.17Zm3.96.07c-.2 0-.4-.04-.55-.12-.17-.08-.3-.2-.4-.33a1 1 0 0 1-.17-.48V47h.4v.02c.02.1.06.2.12.3.07.08.15.15.25.2.1.05.23.08.36.08.14 0 .27-.04.39-.1a.7.7 0 0 0 .26-.28c.06-.11.1-.24.1-.4a.78.78 0 0 0-.1-.4.7.7 0 0 0-.65-.36.9.9 0 0 0-.3.05.73.73 0 0 0-.4.35h-.37l.18-1.92h1.86v.37h-1.53l-.12 1.13h.04a.7.7 0 0 1 .18-.19.98.98 0 0 1 .53-.16 1.06 1.06 0 0 1 .95.55c.09.17.13.36.13.57 0 .23-.05.43-.15.6-.1.18-.23.31-.4.4-.18.1-.38.15-.6.15Z"
        />
        <g clipPath="url(#campaignTracker-h)">
          <rect
            width={65.15}
            height={6.78}
            x={88.43}
            y={53.28}
            fill={templateStyles['background']}
            rx={1.02}
          />
          <path fill={templateStyles['background']} d="M89.44 54.3h4.75v4.74h-4.75z" />
          <path
            fill={templateStyles['link']}
            d="M91.17 56.57c-.05-.05-.12-.05-.15.01l-.77 1.54a.1.1 0 0 0 .08.13h1.07a.09.09 0 0 0 .08-.05c.23-.48.1-1.2-.31-1.63Zm.56-1.4c-.43.68-.4 1.43-.12 2l.52 1.03a.1.1 0 0 0 .08.05h1.07a.1.1 0 0 0 .1-.08.1.1 0 0 0-.02-.05l-1.47-2.95c-.04-.07-.12-.07-.16 0ZM96.5 58.28V55.3h-1.07v-.38H98v.38h-1.08v2.97h-.41Zm2.12 0v-3.5h.4v1.37h.04a.71.71 0 0 1 .27-.3.85.85 0 0 1 .46-.12c.19 0 .34.04.47.11a.7.7 0 0 1 .3.32c.07.13.1.3.1.5v1.62h-.4v-1.52c0-.23-.05-.4-.14-.5-.1-.11-.25-.17-.45-.17a.67.67 0 0 0-.34.09.59.59 0 0 0-.23.24.84.84 0 0 0-.08.38v1.48h-.4Zm3.8.04a1.05 1.05 0 0 1-1-.6c-.1-.2-.15-.42-.15-.68 0-.26.04-.49.14-.69a1.06 1.06 0 0 1 .98-.62 1.01 1.01 0 0 1 .96.6c.09.19.13.4.13.66v.15h-2v-.32h1.8l-.2.3v-.16c0-.2-.03-.36-.1-.49a.63.63 0 0 0-.6-.38.67.67 0 0 0-.36.1.68.68 0 0 0-.25.3c-.06.12-.09.28-.09.47v.16c0 .17.03.33.1.45.05.13.14.22.25.3.11.06.24.1.4.1.1 0 .2-.02.29-.05a.65.65 0 0 0 .2-.12c.06-.05.1-.1.12-.15v-.02h.41v.02a.75.75 0 0 1-.12.25.92.92 0 0 1-.21.21c-.09.07-.2.12-.31.16-.12.03-.25.05-.4.05Zm4.55-.04v-.7h-1.63v-.38l.28-.46a39.98 39.98 0 0 1 1.15-1.8h.6v2.27h.48v.37h-.47v.7h-.41Zm-1.2-1.07h1.2v-1.9h-.03a23.26 23.26 0 0 0-.47.73l-.24.38a40.27 40.27 0 0 0-.47.77v.02Zm4.06 1.07v-2.5h.4v.38h.04a.67.67 0 0 1 .68-.43c.11 0 .21.02.3.06.1.04.17.09.23.15.07.07.12.15.16.23h.04a.8.8 0 0 1 .44-.38c.1-.04.2-.06.32-.06a.9.9 0 0 1 .43.1c.12.06.21.15.27.28.07.12.1.26.1.44v1.73h-.4v-1.64a.7.7 0 0 0-.06-.3.37.37 0 0 0-.18-.19.6.6 0 0 0-.29-.06.55.55 0 0 0-.5.29.59.59 0 0 0-.08.29v1.6h-.4v-1.69c0-.1-.02-.18-.06-.26a.42.42 0 0 0-.18-.17.59.59 0 0 0-.57.03.61.61 0 0 0-.2.23.7.7 0 0 0-.08.32v1.55h-.4Zm4.14 0v-2.5h.4v2.5h-.4Zm.2-2.98a.27.27 0 0 1-.19-.09.27.27 0 0 1-.08-.2c0-.07.03-.14.08-.19a.27.27 0 0 1 .2-.08c.08 0 .14.03.2.08.05.05.08.12.08.2 0 .07-.03.14-.08.2a.27.27 0 0 1-.2.08Zm1.83 3.02c-.19 0-.35-.03-.5-.08a.86.86 0 0 1-.34-.24.67.67 0 0 1-.15-.36h.41c.04.1.1.19.2.25s.23.1.4.1c.1 0 .2-.02.29-.05a.52.52 0 0 0 .2-.14.3.3 0 0 0 .08-.2.27.27 0 0 0-.1-.22.79.79 0 0 0-.34-.15l-.39-.1a1.4 1.4 0 0 1-.38-.14.6.6 0 0 1-.22-.22.64.64 0 0 1-.08-.3c0-.15.04-.27.12-.38.09-.11.2-.2.34-.26s.3-.1.47-.1c.18 0 .33.03.47.09.13.05.24.13.32.23.09.1.14.22.16.35h-.4a.4.4 0 0 0-.18-.24.66.66 0 0 0-.37-.09c-.1 0-.19.02-.26.05a.44.44 0 0 0-.19.13.3.3 0 0 0-.06.2c0 .05.01.1.04.15.03.04.07.08.14.11l.24.09.38.09c.24.06.41.14.53.24.11.11.17.25.17.43 0 .16-.05.29-.13.4-.1.11-.21.2-.36.27-.15.06-.32.1-.51.1Zm2.49-.02c-.26 0-.44-.06-.56-.16-.11-.1-.17-.27-.17-.51V56.1h-.4v-.33h.4v-.65h.42v.65h.54v.33h-.54v1.42c0 .14.02.25.08.31.06.07.15.1.28.1a1.45 1.45 0 0 0 .18-.01v.34a3.4 3.4 0 0 1-.23.03Zm1.52.02a.98.98 0 0 1-.42-.09.73.73 0 0 1-.3-.26.7.7 0 0 1-.11-.4c0-.14.03-.27.1-.38a.7.7 0 0 1 .32-.25c.13-.06.3-.1.49-.1l.92-.06v.32l-.87.06a.76.76 0 0 0-.42.12.34.34 0 0 0-.13.29c0 .13.05.23.14.3.1.07.22.1.37.1a.8.8 0 0 0 .36-.08c.1-.06.2-.13.25-.23.07-.09.1-.2.1-.31v-.78c0-.16-.05-.28-.15-.36-.09-.08-.23-.12-.41-.12a.75.75 0 0 0-.37.08.39.39 0 0 0-.2.23h-.4v-.01a.68.68 0 0 1 .16-.34c.1-.1.2-.18.34-.23.14-.06.3-.09.48-.09.2 0 .38.04.52.1a.7.7 0 0 1 .32.3c.07.11.1.26.1.44v1.7h-.4v-.36h-.03a.85.85 0 0 1-.45.36 1 1 0 0 1-.3.05Zm1.96-.04v-3.5h.4v3.5h-.4Zm1.57 0-.97-1.23.3-.25 1.18 1.48h-.5Zm-1.22-.9-.02-.51h.11l1.08-1.1h.49l-1.19 1.15-.1.1-.37.36Zm3.11.94a1.05 1.05 0 0 1-1-.6c-.1-.2-.15-.42-.15-.68 0-.26.05-.49.14-.69.1-.19.22-.34.4-.45.16-.11.36-.17.58-.17.23 0 .43.06.59.16.16.1.29.25.37.44.1.19.14.4.14.66v.15h-2v-.32h1.79l-.2.3v-.16c0-.2-.03-.36-.09-.49a.62.62 0 0 0-.6-.38.67.67 0 0 0-.36.1.67.67 0 0 0-.25.3c-.06.12-.1.28-.1.47v.16c0 .17.04.33.1.45a.67.67 0 0 0 .65.4c.11 0 .21-.02.3-.05a.64.64 0 0 0 .2-.12c.05-.05.1-.1.11-.15l.01-.02h.4v.02a.75.75 0 0 1-.11.25.92.92 0 0 1-.22.21c-.08.07-.19.12-.3.16-.12.03-.25.05-.4.05Zm2.55 0c-.19 0-.35-.03-.5-.08a.86.86 0 0 1-.34-.24.66.66 0 0 1-.14-.36h.4c.04.1.1.19.2.25s.23.1.4.1c.1 0 .2-.02.3-.05a.52.52 0 0 0 .2-.14.3.3 0 0 0 .07-.2.27.27 0 0 0-.1-.22.78.78 0 0 0-.34-.15l-.38-.1a1.42 1.42 0 0 1-.39-.14.6.6 0 0 1-.22-.22.65.65 0 0 1-.07-.3c0-.15.04-.27.12-.38.08-.11.19-.2.33-.26s.3-.1.48-.1c.17 0 .33.03.46.09.14.05.25.13.33.23.08.1.13.22.15.35h-.4a.41.41 0 0 0-.18-.24.66.66 0 0 0-.37-.09c-.1 0-.18.02-.26.05a.43.43 0 0 0-.18.13.3.3 0 0 0-.07.2c0 .05.01.1.04.15.03.04.08.08.14.11l.24.09.38.09c.24.06.41.14.53.24.11.11.17.25.17.43 0 .16-.04.29-.13.4-.09.11-.2.2-.36.27-.15.06-.32.1-.51.1Zm3.18.83a.96.96 0 0 1-.18-.01v-.33h.08l.09.01c.11 0 .2-.03.28-.09a.6.6 0 0 0 .17-.3l.05-.15-.92-2.5h.43l.77 2.3-.16-.25h.19l-.16.26.76-2.31h.43l-.98 2.65c-.06.19-.14.33-.21.44a.62.62 0 0 1-.27.22.94.94 0 0 1-.37.06Zm3.3-.83c-.24 0-.45-.05-.62-.15-.17-.1-.3-.26-.4-.45-.09-.2-.14-.42-.14-.69 0-.27.05-.5.14-.7.1-.19.23-.34.4-.44.17-.1.38-.16.62-.16.23 0 .44.06.61.16.17.1.3.25.4.44.1.2.14.43.14.7 0 .27-.05.5-.14.69a1.04 1.04 0 0 1-1.01.6Zm0-.36a.7.7 0 0 0 .4-.1.7.7 0 0 0 .25-.33c.06-.14.09-.3.09-.5s-.03-.37-.1-.51a.68.68 0 0 0-.24-.32.7.7 0 0 0-.4-.11.7.7 0 0 0-.4.11c-.11.07-.2.18-.26.32s-.08.3-.08.5v.01c0 .2.03.36.08.5a.7.7 0 0 0 .25.32.7.7 0 0 0 .4.11Zm2.61.36a.97.97 0 0 1-.47-.1.69.69 0 0 1-.3-.32c-.06-.14-.09-.3-.09-.5v-1.62h.4v1.52c0 .22.05.39.13.5.1.1.24.16.44.16a.8.8 0 0 0 .29-.04.58.58 0 0 0 .21-.14.6.6 0 0 0 .13-.23.92.92 0 0 0 .04-.3v-1.47h.4v2.5h-.4v-.38h-.04a.68.68 0 0 1-.41.37c-.1.03-.2.05-.33.05Zm1.94-2.07.2-1.32h.46l-.36 1.32h-.3Zm1.4 2.03v-2.5h.41v.37h.04a.6.6 0 0 1 .24-.3c.12-.08.26-.12.43-.12a1.29 1.29 0 0 1 .2.02v.4a1.2 1.2 0 0 0-.25-.03.74.74 0 0 0-.34.07.59.59 0 0 0-.23.22.6.6 0 0 0-.09.32v1.55h-.4Zm2.77.04a1.05 1.05 0 0 1-1-.6c-.1-.2-.15-.42-.15-.68 0-.26.05-.49.14-.69.1-.19.22-.34.4-.45.16-.11.36-.17.58-.17.23 0 .42.06.59.16.16.1.28.25.37.44.09.19.13.4.13.66v.15h-2v-.32h1.8l-.2.3v-.16c0-.2-.03-.36-.09-.49a.63.63 0 0 0-.6-.38.67.67 0 0 0-.36.1.68.68 0 0 0-.25.3c-.06.12-.1.28-.1.47v.16c0 .17.03.33.1.45.06.13.14.22.25.3.11.06.25.1.4.1.11 0 .2-.02.3-.05a.65.65 0 0 0 .2-.12c.05-.05.09-.1.11-.15l.01-.02h.4v.02a.75.75 0 0 1-.12.25.92.92 0 0 1-.2.21c-.1.07-.2.12-.32.16-.11.03-.25.05-.4.05Zm4.05 0a1.06 1.06 0 0 1-1-.61c-.1-.2-.15-.43-.15-.69 0-.26.05-.49.14-.68a1.05 1.05 0 0 1 1-.6c.2 0 .38.03.53.1a.92.92 0 0 1 .52.69v.01h-.4a.58.58 0 0 0-.21-.32.68.68 0 0 0-.43-.13.67.67 0 0 0-.65.44c-.06.13-.09.3-.09.49 0 .2.03.36.1.5a.66.66 0 0 0 .64.44c.16 0 .3-.03.4-.1a.6.6 0 0 0 .24-.32v-.02h.4v.03c-.04.15-.1.28-.18.4-.09.11-.2.2-.35.27-.14.07-.31.1-.51.1Zm1.96-.02a.3.3 0 0 1-.21-.09.3.3 0 0 1-.09-.21c0-.08.03-.16.09-.21a.3.3 0 0 1 .21-.1.3.3 0 0 1 .22.1.3.3 0 0 1 .08.2.3.3 0 0 1-.3.31Zm1.2 0a.3.3 0 0 1-.2-.09.3.3 0 0 1-.1-.21c0-.08.04-.16.1-.21a.3.3 0 0 1 .2-.1c.1 0 .16.04.22.1a.3.3 0 0 1 .09.2.3.3 0 0 1-.09.22.29.29 0 0 1-.21.09Zm1.21 0a.3.3 0 0 1-.2-.09.3.3 0 0 1-.1-.21.3.3 0 0 1 .1-.21.3.3 0 0 1 .2-.1.3.3 0 0 1 .22.1c.06.05.09.13.09.2a.3.3 0 0 1-.1.22.3.3 0 0 1-.2.09Z"
          />
        </g>
        <rect
          width={65.15}
          height={6.78}
          x={88.43}
          y={53.28}
          stroke={templateStyles['border']}
          strokeWidth={0.34}
          rx={1.02}
        />
      </g>
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M108.42 74.23v2.12h.51v-2.12h2.12v-.5h-2.12V71.6h-.5v2.12h-2.13v.5h2.13Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontFamily']}
        fontSize={4.75}
        fontWeight={510}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={113.03} y={75.56}>
          {formatMessage(messages['templates-preview.add-entry'])}
        </tspan>
      </text>
      <rect
        width={76}
        height={133}
        x={162}
        y={4}
        fill={templateStyles['boardBackground']}
        rx={1.02}
      />
      <rect
        width={22.7}
        height={6.48}
        x={164.86}
        y={8.22}
        fill={tagBackgroundColors['redLight']}
        rx={0.87}
      />
      <rect
        width={22.7}
        height={6.48}
        x={164.86}
        y={8.22}
        stroke={tagBorderColors['redLight']}
        strokeWidth={0.3}
        rx={0.87}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontFamily']}
        fontSize={4.75}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={166.8} y={13.04}>
          {formatMessage(
            campaignTrackerMessages['campaign-tracker.field-5-select-option-3']
          )}
        </tspan>
      </text>
      <g filter="url(#campaignTracker-i)">
        <rect
          width={70.57}
          height={52.21}
          x={164.71}
          y={18.92}
          fill={templateStyles['background']}
          rx={1.36}
        />
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={5.43}
          fontWeight="bold"
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={167.43} y={28.32}>
            {formatMessage(
              campaignTrackerMessages['campaign-tracker.entry-2-cell-5']
            ).substring(0, 19)}
          </tspan>
          <tspan x={167.43} y={35.1}>
            {formatMessage(
              campaignTrackerMessages['campaign-tracker.entry-2-cell-5']
            ).substring(19)}
          </tspan>
        </text>
        <rect
          width={41.7}
          height={6.48}
          x={167.58}
          y={39.86}
          fill={tagBackgroundColors['teal']}
          rx={0.87}
        />
        <rect
          width={41.7}
          height={6.48}
          x={167.58}
          y={39.86}
          stroke={tagBorderColors['teal']}
          strokeWidth={0.3}
          rx={0.87}
        />
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={4.75}
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={168.5} y={44.68}>
            {formatMessage(
              campaignTrackerMessages['campaign-tracker.field-2-select-option-3']
            )}
          </tspan>
        </text>
        <rect
          width={32.71}
          height={8.36}
          x={167.43}
          y={49.21}
          fill={templateStyles['userBackground']}
          rx={1.02}
        />
        <path
          fill={templateStyles['fontColor']}
          d="M169.21 54.89v-3.35h1.15c.33 0 .61.07.85.2.23.13.41.32.54.57.13.25.19.55.19.9a2 2 0 0 1-.19.9c-.13.25-.3.45-.54.58-.24.13-.52.2-.85.2h-1.15Zm.42-.38h.7c.25 0 .46-.05.64-.15a1 1 0 0 0 .4-.45c.1-.19.14-.42.14-.7 0-.27-.05-.5-.14-.7a1 1 0 0 0-.4-.44c-.18-.1-.4-.16-.64-.16h-.7v2.6Zm4 .42a1.04 1.04 0 0 1-1-.6c-.1-.2-.15-.42-.15-.69 0-.26.05-.48.14-.68.1-.2.22-.34.4-.45.16-.11.36-.17.58-.17a1.01 1.01 0 0 1 .96.6c.1.19.14.4.14.65v.16h-2v-.32h1.8l-.2.3v-.17c0-.2-.04-.35-.1-.48a.63.63 0 0 0-.6-.38.67.67 0 0 0-.36.1.67.67 0 0 0-.25.29c-.06.13-.1.29-.1.47v.16c0 .18.04.33.1.46a.67.67 0 0 0 .65.39c.11 0 .21-.02.3-.05a.64.64 0 0 0 .2-.11c.06-.05.1-.1.11-.15l.01-.02h.4v.02a.75.75 0 0 1-.11.24.92.92 0 0 1-.22.22c-.08.06-.18.11-.3.15-.12.04-.25.06-.4.06Zm2.72 0c-.24 0-.44-.05-.61-.16-.17-.1-.3-.26-.4-.45-.1-.2-.14-.43-.14-.7 0-.26.04-.48.14-.67.1-.2.22-.34.4-.45.17-.1.37-.16.6-.16.2 0 .38.04.53.1a.93.93 0 0 1 .52.7v.01h-.4a.57.57 0 0 0-.21-.32.68.68 0 0 0-.44-.13.67.67 0 0 0-.64.43c-.06.14-.09.3-.09.5 0 .19.03.36.1.5a.66.66 0 0 0 .64.44c.16 0 .3-.03.4-.1a.6.6 0 0 0 .24-.32v-.02h.4v.02c-.04.15-.1.29-.19.4-.08.12-.2.21-.34.28-.14.07-.31.1-.51.1Zm3.78-.04V52h-.03l-.86.62v-.44l.9-.64h.41v3.35h-.42Zm2.49.07c-.21 0-.4-.04-.56-.12a1 1 0 0 1-.56-.81V54h.4v.02a.64.64 0 0 0 .37.5c.1.05.22.08.35.08.15 0 .28-.04.4-.1a.7.7 0 0 0 .26-.28c.06-.11.1-.24.1-.4a.78.78 0 0 0-.1-.4.69.69 0 0 0-.27-.26.75.75 0 0 0-.38-.1.9.9 0 0 0-.31.05.72.72 0 0 0-.33.24.74.74 0 0 0-.07.11h-.36l.17-1.92h1.86v.37h-1.53l-.11 1.13h.04a.68.68 0 0 1 .18-.19.98.98 0 0 1 .53-.16c.2 0 .4.05.56.15.16.1.29.23.38.4.1.17.14.36.14.57 0 .23-.05.43-.15.6-.1.18-.24.31-.41.4-.18.1-.38.15-.6.15Zm1.57.78.2-1.32h.46l-.36 1.32h-.3Zm2.84-.85v-.3l1.14-1.22.33-.38c.08-.1.14-.2.17-.28a.73.73 0 0 0 .05-.26.64.64 0 0 0-.08-.32.57.57 0 0 0-.22-.22.67.67 0 0 0-.33-.09.72.72 0 0 0-.35.09.58.58 0 0 0-.24.23.69.69 0 0 0-.08.34h-.4a1 1 0 0 1 .52-.89c.17-.09.36-.13.57-.13.2 0 .37.04.53.12.16.08.28.2.37.33.09.15.14.3.14.49 0 .13-.03.25-.07.37-.05.12-.12.25-.23.39-.11.14-.27.32-.47.53l-.87.89.1-.2v.2l-.1-.07h1.7v.38h-2.18Zm4 .07a.98.98 0 0 1-.64-.2c-.18-.15-.31-.35-.4-.61-.1-.27-.15-.58-.15-.94s.05-.67.14-.93c.1-.26.23-.46.4-.6a.98.98 0 0 1 .64-.22c.25 0 .46.07.64.21.17.15.3.35.4.6.1.27.15.58.15.94s-.05.67-.15.94c-.1.26-.23.46-.4.6a.98.98 0 0 1-.64.21Zm0-.36c.15 0 .29-.06.4-.17.12-.11.2-.27.26-.48.06-.2.1-.45.1-.74s-.03-.53-.1-.74c-.06-.2-.14-.36-.26-.47a.56.56 0 0 0-.4-.17c-.17 0-.3.05-.42.17-.11.1-.2.27-.26.47-.06.2-.09.45-.09.74s.03.53.1.74c.05.2.14.37.25.48.11.11.25.17.41.17Zm1.86.29v-.3l1.13-1.22c.15-.15.26-.28.34-.38.08-.1.13-.2.17-.28a.71.71 0 0 0 .05-.26.64.64 0 0 0-.08-.32.56.56 0 0 0-.22-.22.67.67 0 0 0-.34-.09.7.7 0 0 0-.35.09.58.58 0 0 0-.23.23.69.69 0 0 0-.09.34h-.4a.97.97 0 0 1 .53-.89c.17-.09.36-.13.57-.13.2 0 .37.04.53.12.15.08.28.2.37.33a1.02 1.02 0 0 1 .07.85 1.5 1.5 0 0 1-.24.4c-.1.14-.26.32-.47.53l-.86.89.1-.2v.2l-.1-.07h1.69v.38h-2.17Zm3.97.07c-.21 0-.4-.04-.56-.12-.16-.08-.29-.2-.39-.33a1 1 0 0 1-.17-.48V54h.4v.02a.64.64 0 0 0 .37.5c.1.05.22.08.35.08.15 0 .28-.04.4-.1a.7.7 0 0 0 .26-.28c.06-.11.1-.24.1-.4a.78.78 0 0 0-.1-.4.69.69 0 0 0-.27-.26.75.75 0 0 0-.38-.1.9.9 0 0 0-.3.05.72.72 0 0 0-.34.24.74.74 0 0 0-.07.11h-.36l.17-1.92h1.87v.37h-1.54l-.11 1.13h.04a.68.68 0 0 1 .18-.19.99.99 0 0 1 .53-.16c.21 0 .4.05.56.15.16.1.29.23.38.4.1.17.14.36.14.57 0 .23-.05.43-.15.6-.1.18-.24.31-.41.4-.17.1-.38.15-.6.15Z"
        />
        <g clipPath="url(#campaignTracker-j)">
          <rect
            width={65.15}
            height={6.78}
            x={167.43}
            y={60.28}
            fill={templateStyles['background']}
            rx={1.02}
          />
          <path fill={templateStyles['background']} d="M168.44 61.3h4.75v4.74h-4.75z" />
          <path
            fill={templateStyles['link']}
            d="M170.17 63.57c-.05-.05-.12-.05-.16.01l-.76 1.54-.01.04.01.05.03.03.05.01h1.07a.1.1 0 0 0 .05-.01l.03-.04c.23-.48.1-1.2-.31-1.63Zm.56-1.4c-.43.68-.4 1.43-.12 2l.52 1.03a.1.1 0 0 0 .08.05h1.12l.03-.04a.1.1 0 0 0 .01-.04.1.1 0 0 0 0-.05l-1.48-2.95c-.03-.07-.12-.07-.16 0ZM175 64.16l-.01-.6h.1l1.47-1.63h.52l-1.38 1.5-.2.18-.5.55Zm-.36 1.12v-3.35h.42v3.35h-.42Zm2.03 0-1.25-1.67.28-.29 1.5 1.96h-.53Zm1.06 0v-2.5h.4v2.5h-.4Zm.2-2.98a.27.27 0 0 1-.2-.09.27.27 0 0 1-.08-.2c0-.07.03-.14.08-.19a.27.27 0 0 1 .2-.08c.08 0 .14.03.2.08.05.05.08.12.08.2 0 .07-.03.14-.08.2a.27.27 0 0 1-.2.08Zm1.98 3.02a1.06 1.06 0 0 1-1-.61c-.1-.2-.15-.43-.15-.69 0-.26.05-.49.15-.68a1.05 1.05 0 0 1 1-.6c.2 0 .38.03.53.1a.92.92 0 0 1 .52.69v.01h-.4a.58.58 0 0 0-.22-.32.68.68 0 0 0-.43-.13.67.67 0 0 0-.64.44c-.06.13-.1.3-.1.49 0 .2.04.36.1.5.06.14.14.25.25.33.11.08.24.11.4.11.16 0 .3-.03.4-.1a.6.6 0 0 0 .23-.32v-.02h.4v.03c-.03.15-.1.28-.18.4-.09.11-.2.2-.34.27s-.32.1-.52.1Zm1.66-.04v-3.5h.4v3.5h-.4Zm1.58 0-.98-1.23.3-.25 1.18 1.48h-.5Zm-1.23-.9-.01-.51h.1l1.08-1.1h.5l-1.2 1.15-.1.1-.37.36Zm4.57.94c-.24 0-.44-.05-.62-.15-.17-.1-.3-.26-.4-.45-.09-.2-.13-.42-.13-.69 0-.27.04-.5.14-.7.09-.19.22-.34.4-.44.17-.1.37-.16.6-.16.25 0 .45.06.62.16.18.1.3.25.4.44.1.2.14.43.14.7 0 .27-.04.5-.14.69a1.04 1.04 0 0 1-1.01.6Zm0-.36a.7.7 0 0 0 .4-.1c.11-.08.2-.19.25-.33.06-.14.09-.3.09-.5s-.03-.37-.09-.51a.67.67 0 0 0-.25-.32.7.7 0 0 0-.4-.11.7.7 0 0 0-.4.11.69.69 0 0 0-.25.32c-.06.14-.09.3-.09.5v.01c0 .2.03.36.09.5a.7.7 0 0 0 .25.32.7.7 0 0 0 .4.11Zm1.94.32V63.1h-.41v-.33h.41v-.28c0-.17.03-.3.09-.41.05-.11.13-.2.24-.25.11-.05.24-.08.4-.08a1.34 1.34 0 0 1 .27.02v.33l-.09-.01h-.1c-.14 0-.25.03-.3.1-.07.07-.1.17-.1.31v.27h.57v.33h-.57v2.17h-.4Zm1.72 0V63.1h-.41v-.33h.41v-.28c0-.17.03-.3.09-.41.05-.11.13-.2.24-.25.11-.05.24-.08.4-.08a1.32 1.32 0 0 1 .27.02v.33l-.09-.01h-.1c-.14 0-.25.03-.3.1-.07.07-.1.17-.1.31v.27h.57v.33h-.57v2.17h-.4Zm3.78.02c-.25 0-.44-.06-.56-.16-.11-.1-.17-.27-.17-.51V63.1h-.4v-.33h.4v-.65h.42v.65h.55v.33h-.55v1.42c0 .14.03.25.08.31.06.07.15.1.28.1a1.45 1.45 0 0 0 .19-.01v.34a3.4 3.4 0 0 1-.24.03Zm.86-.02v-3.5h.4v1.37h.04a.71.71 0 0 1 .28-.3.84.84 0 0 1 .45-.12c.19 0 .35.04.48.11a.7.7 0 0 1 .3.32c.06.13.1.3.1.5v1.62h-.4v-1.52c0-.23-.06-.4-.15-.5-.1-.11-.24-.17-.44-.17a.67.67 0 0 0-.35.09.59.59 0 0 0-.22.24.84.84 0 0 0-.08.38v1.48h-.4Zm3.8.04c-.24 0-.45-.05-.62-.16-.17-.1-.3-.25-.4-.44-.08-.2-.13-.42-.13-.68 0-.26.05-.49.14-.69a1.06 1.06 0 0 1 .98-.62c.23 0 .42.06.59.16.16.1.28.25.37.44.09.19.13.4.13.66v.15h-2v-.32h1.8l-.2.3v-.16c0-.2-.03-.36-.1-.49a.63.63 0 0 0-.6-.38.67.67 0 0 0-.35.1.68.68 0 0 0-.25.3c-.07.12-.1.28-.1.47v.16c0 .17.03.33.1.45a.67.67 0 0 0 .65.4c.1 0 .2-.02.29-.05a.64.64 0 0 0 .2-.12c.06-.05.1-.1.12-.15v-.02h.41v.02a.77.77 0 0 1-.12.25.92.92 0 0 1-.2.21c-.1.07-.2.12-.32.16-.11.03-.25.05-.4.05Zm3.03-.04v-2.5h.4v.37h.03a.71.71 0 0 1 .28-.3.84.84 0 0 1 .45-.12c.28 0 .5.08.65.24.15.16.23.4.23.69v1.62h-.4v-1.52c0-.23-.05-.4-.15-.5-.1-.11-.24-.17-.44-.17a.67.67 0 0 0-.35.09.59.59 0 0 0-.22.24.83.83 0 0 0-.08.38v1.48h-.4Zm3.79.04a1.05 1.05 0 0 1-1-.6c-.1-.2-.15-.42-.15-.68 0-.26.05-.49.14-.69a1.06 1.06 0 0 1 .98-.62c.23 0 .42.06.59.16.16.1.29.25.37.44.1.19.13.4.13.66v.15h-2v-.32h1.8l-.2.3v-.16c0-.2-.03-.36-.09-.49a.62.62 0 0 0-.6-.38.67.67 0 0 0-.36.1.67.67 0 0 0-.25.3c-.06.12-.1.28-.1.47v.16c0 .17.04.33.1.45a.67.67 0 0 0 .65.4c.11 0 .2-.02.3-.05a.65.65 0 0 0 .2-.12c.05-.05.09-.1.11-.15l.01-.02h.4v.02a.77.77 0 0 1-.12.25.92.92 0 0 1-.2.21c-.1.07-.2.12-.31.16-.12.03-.25.05-.4.05Zm2.17-.04-.7-2.5h.4l.5 2h.03l.56-2h.39l.56 2h.03l.5-2h.4l-.7 2.5h-.41l-.56-1.94h-.04l-.55 1.94h-.4Zm4.75.87a.98.98 0 0 1-.18-.01v-.33h.08l.09.01c.11 0 .2-.03.28-.09a.61.61 0 0 0 .18-.3l.04-.15-.92-2.5h.43l.77 2.3-.16-.25h.19l-.16.26.77-2.31h.42l-.98 2.65c-.06.19-.14.33-.21.44a.61.61 0 0 1-.27.22.95.95 0 0 1-.37.06Zm3.29-.83a1.05 1.05 0 0 1-1-.6c-.1-.2-.15-.42-.15-.68 0-.26.05-.49.14-.69a1.06 1.06 0 0 1 .98-.62 1 1 0 0 1 .96.6c.1.19.14.4.14.66v.15h-2v-.32h1.79l-.2.3v-.16c0-.2-.03-.36-.09-.49a.62.62 0 0 0-.6-.38.67.67 0 0 0-.36.1.67.67 0 0 0-.25.3c-.06.12-.1.28-.1.47v.16c0 .17.04.33.1.45a.67.67 0 0 0 .65.4c.11 0 .21-.02.3-.05a.65.65 0 0 0 .2-.12c.05-.05.1-.1.11-.15l.01-.02h.4v.02a.77.77 0 0 1-.11.25.94.94 0 0 1-.52.37 1.3 1.3 0 0 1-.4.05Zm2.38 0a.98.98 0 0 1-.43-.09.73.73 0 0 1-.3-.26.71.71 0 0 1-.1-.4c0-.14.03-.27.1-.38a.7.7 0 0 1 .31-.25c.14-.06.3-.1.5-.1l.91-.06v.32l-.87.06a.76.76 0 0 0-.41.12.34.34 0 0 0-.13.29c0 .13.04.23.14.3.1.07.22.1.36.1a.8.8 0 0 0 .37-.08c.1-.06.19-.13.25-.23.06-.09.1-.2.1-.31v-.78c0-.16-.06-.28-.15-.36-.1-.08-.23-.12-.42-.12a.75.75 0 0 0-.37.08.39.39 0 0 0-.19.23h-.4v-.01a.67.67 0 0 1 .16-.34c.09-.1.2-.18.34-.23.14-.06.3-.09.47-.09.2 0 .38.04.52.1a.7.7 0 0 1 .32.3c.08.11.12.26.12.44v1.7h-.4v-.36h-.05a.85.85 0 0 1-.44.36 1 1 0 0 1-.31.05Zm1.93-.04v-2.5h.4v.37h.04a.6.6 0 0 1 .25-.3c.11-.08.25-.12.42-.12a1.29 1.29 0 0 1 .2.02v.4a1.2 1.2 0 0 0-.25-.03.74.74 0 0 0-.34.07.59.59 0 0 0-.23.22.6.6 0 0 0-.08.32v1.55h-.4Zm3.63 0-.7-2.5h.4l.5 2h.03l.56-2h.38l.56 2h.04l.49-2h.4l-.7 2.5h-.4l-.56-1.94h-.04l-.56 1.94h-.4Zm3.2 0v-2.5h.4v2.5h-.4Zm.2-2.98a.27.27 0 0 1-.19-.09.27.27 0 0 1-.08-.2.27.27 0 0 1 .28-.28c.07 0 .14.04.2.09.05.05.08.12.08.2 0 .07-.03.14-.09.2a.27.27 0 0 1-.2.08Zm1.3 3a.3.3 0 0 1-.22-.09.3.3 0 0 1-.08-.21c0-.08.03-.16.08-.21a.3.3 0 0 1 .22-.1.3.3 0 0 1 .21.1.3.3 0 0 1 .09.2.3.3 0 0 1-.3.31Zm1.2 0a.3.3 0 0 1-.21-.09.3.3 0 0 1-.09-.21c0-.08.03-.16.09-.21a.3.3 0 0 1 .21-.1c.09 0 .16.04.22.1.06.05.08.13.08.2a.3.3 0 0 1-.08.22.29.29 0 0 1-.22.09Zm1.2 0a.3.3 0 0 1-.3-.3.3.3 0 0 1 .3-.3.3.3 0 0 1 .22.09c.06.05.09.13.09.2a.3.3 0 0 1-.09.22.3.3 0 0 1-.21.09Z"
          />
        </g>
        <rect
          width={65.15}
          height={6.78}
          x={167.43}
          y={60.28}
          stroke={templateStyles['border']}
          strokeWidth={0.34}
          rx={1.02}
        />
      </g>
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M187.43 81.23v2.12h.5v-2.12h2.12v-.5h-2.12V78.6h-.5v2.12h-2.13v.5h2.13Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontFamily']}
        fontSize={4.75}
        fontWeight={510}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={192.03} y={82.56}>
          {formatMessage(messages['templates-preview.add-entry'])}
        </tspan>
      </text>
      <rect
        width={76}
        height={133}
        x={241}
        y={4}
        fill={templateStyles['boardBackground']}
        rx={1.02}
      />
      <rect
        width={15.7}
        height={6.48}
        x={243.86}
        y={8.22}
        fill={tagBackgroundColors['greenLight']}
        rx={0.87}
      />
      <rect
        width={15.7}
        height={6.48}
        x={243.86}
        y={8.22}
        stroke={tagBorderColors['greenLight']}
        strokeWidth={0.3}
        rx={0.87}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontFamily']}
        fontSize={4.75}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={245.3} y={13.04}>
          {formatMessage(
            campaignTrackerMessages['campaign-tracker.field-5-select-option-4']
          )}
        </tspan>
      </text>
      <g filter="url(#campaignTracker-k)">
        <rect
          width={70.57}
          height={45.21}
          x={243.71}
          y={18.92}
          fill={templateStyles['background']}
          rx={1.36}
        />
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={5.43}
          fontWeight="bold"
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={246.43} y={28.32}>
            {formatMessage(campaignTrackerMessages['campaign-tracker.entry-3-cell-5'])}
          </tspan>
        </text>
        <rect
          width={41.7}
          height={6.48}
          x={246.58}
          y={32.86}
          fill={tagBackgroundColors['lime']}
          rx={0.87}
        />
        <rect
          width={41.7}
          height={6.48}
          x={246.58}
          y={32.86}
          stroke={tagBorderColors['lime']}
          strokeWidth={0.3}
          rx={0.87}
        />
        <text
          xmlSpace="preserve"
          fill={templateStyles['fontColor']}
          fontFamily={templateStyles['fontFamily']}
          fontSize={4.75}
          letterSpacing="0em"
          style={{
            whiteSpace: 'pre'
          }}
        >
          <tspan x={247.59} y={37.68}>
            {formatMessage(
              campaignTrackerMessages['campaign-tracker.field-2-select-option-4']
            )}
          </tspan>
        </text>
        <rect
          width={33.71}
          height={8.36}
          x={246.43}
          y={42.21}
          fill={templateStyles['userBackground']}
          rx={1.02}
        />
        <path
          fill={templateStyles['fontColor']}
          d="M248.21 47.89v-3.35h.48l1.15 2.8h.04l1.14-2.8h.49v3.35h-.4v-2.56h-.2l.47-.7-1.34 3.26h-.36l-1.34-3.26.46.7h-.2v2.56h-.39Zm4.79.04a.98.98 0 0 1-.43-.1.73.73 0 0 1-.3-.25.7.7 0 0 1-.1-.4c0-.15.03-.27.1-.38a.7.7 0 0 1 .3-.25c.15-.06.31-.1.5-.1l.92-.06v.32l-.87.06a.76.76 0 0 0-.42.12.35.35 0 0 0-.13.28c0 .13.05.23.15.3.1.07.22.1.36.1a.8.8 0 0 0 .37-.07c.1-.06.19-.13.25-.23s.09-.2.09-.32v-.78c0-.15-.05-.27-.14-.35-.1-.08-.23-.12-.42-.12a.75.75 0 0 0-.37.08.4.4 0 0 0-.2.22v.01h-.4V46a.68.68 0 0 1 .17-.35c.08-.1.2-.17.34-.23.14-.05.3-.08.47-.08.2 0 .38.03.52.1a.7.7 0 0 1 .32.29c.08.12.11.27.11.44v1.72h-.4v-.37h-.04a.85.85 0 0 1-.44.36c-.1.03-.2.05-.31.05Zm1.93-.04v-2.5h.4v.37h.04a.59.59 0 0 1 .25-.31c.1-.07.25-.1.42-.1H256.25v.4a1.17 1.17 0 0 0-.26-.02.73.73 0 0 0-.34.07.6.6 0 0 0-.23.22.6.6 0 0 0-.09.32v1.55h-.4Zm3.14 0v-.3l1.13-1.22c.15-.15.26-.28.34-.38.08-.1.13-.2.17-.28a.71.71 0 0 0 .05-.26.64.64 0 0 0-.08-.32.56.56 0 0 0-.22-.22.67.67 0 0 0-.34-.09.7.7 0 0 0-.35.09.57.57 0 0 0-.23.23.68.68 0 0 0-.09.34h-.4a.97.97 0 0 1 .53-.89c.17-.09.36-.13.57-.13.2 0 .37.04.53.12.15.08.28.2.37.33a1.02 1.02 0 0 1 .07.85 1.5 1.5 0 0 1-.24.4c-.1.14-.26.32-.47.53l-.86.89.1-.2v.2l-.1-.07h1.69v.38h-2.17Zm4.01.05c-.23 0-.44-.04-.63-.12-.18-.08-.32-.2-.43-.34a.83.83 0 0 1-.15-.5.83.83 0 0 1 .34-.69c.1-.08.23-.14.38-.17a.9.9 0 0 1-.44-.3.7.7 0 0 1-.16-.45c0-.18.04-.33.14-.46s.22-.23.39-.31c.16-.08.35-.12.56-.12.21 0 .4.04.56.12.17.08.3.18.4.31.09.13.14.28.14.45a.7.7 0 0 1-.17.47.88.88 0 0 1-.43.28v.01a.92.92 0 0 1 .63.47c.06.12.09.25.09.39 0 .19-.06.35-.16.5-.1.14-.25.26-.43.34-.18.08-.4.12-.63.12Zm0-.36a1 1 0 0 0 .41-.08.7.7 0 0 0 .28-.22c.07-.1.1-.2.1-.32a.54.54 0 0 0-.1-.33.67.67 0 0 0-.28-.23.98.98 0 0 0-.4-.08c-.16 0-.3.03-.42.08a.69.69 0 0 0-.28.23c-.07.09-.1.2-.1.32 0 .13.03.23.1.33.07.09.16.16.28.22a1 1 0 0 0 .41.08Zm0-1.62c.14 0 .25-.03.36-.07.1-.05.18-.12.24-.2a.5.5 0 0 0 .08-.29.5.5 0 0 0-.08-.3.56.56 0 0 0-.24-.19.82.82 0 0 0-.36-.07.83.83 0 0 0-.35.07.56.56 0 0 0-.24.2.5.5 0 0 0-.09.29c0 .11.03.2.09.29.06.08.13.15.24.2.1.04.22.07.35.07Zm1.63 2.78.2-1.32h.46l-.36 1.32h-.3Zm2.85-.85v-.3l1.13-1.22.33-.38c.08-.1.14-.2.17-.28a.71.71 0 0 0 .05-.26.64.64 0 0 0-.08-.32.56.56 0 0 0-.22-.22.67.67 0 0 0-.33-.09.7.7 0 0 0-.36.09.57.57 0 0 0-.23.23.68.68 0 0 0-.08.34h-.4a.97.97 0 0 1 .53-.89c.16-.09.35-.13.56-.13.2 0 .37.04.53.12.15.08.28.2.37.33.09.15.14.3.14.49 0 .13-.03.25-.07.37a1.5 1.5 0 0 1-.24.39c-.1.14-.26.32-.47.53l-.86.89.1-.2v.2l-.1-.07h1.69v.38h-2.17Zm3.98.07a.98.98 0 0 1-.64-.2c-.17-.15-.3-.35-.4-.61-.1-.27-.14-.58-.14-.94s.05-.67.14-.93c.1-.26.23-.46.4-.6a.98.98 0 0 1 .64-.22c.25 0 .46.07.64.21.17.15.3.35.4.6.1.27.15.58.15.94s-.05.67-.15.94c-.1.26-.23.46-.4.6a.98.98 0 0 1-.64.21Zm0-.36c.16 0 .3-.06.41-.17.12-.11.2-.27.26-.48.06-.2.1-.45.1-.74s-.04-.53-.1-.74c-.06-.2-.14-.36-.26-.47a.56.56 0 0 0-.41-.17c-.16 0-.3.05-.41.17-.11.1-.2.27-.26.47-.06.2-.09.45-.09.74s.03.53.09.74c.06.2.15.37.26.48.11.11.25.17.41.17Zm1.87.29v-.3l1.13-1.22.34-.38c.08-.1.13-.2.17-.28a.71.71 0 0 0 .05-.26.64.64 0 0 0-.08-.32.57.57 0 0 0-.22-.22.67.67 0 0 0-.34-.09.7.7 0 0 0-.35.09.58.58 0 0 0-.23.23.68.68 0 0 0-.09.34h-.4a.98.98 0 0 1 .53-.89c.17-.09.36-.13.57-.13.2 0 .37.04.53.12.15.08.28.2.37.33.09.15.13.3.13.49 0 .13-.02.25-.06.37-.05.12-.13.25-.24.39-.1.14-.27.32-.47.53l-.86.89.1-.2v.2l-.1-.07h1.69v.38h-2.17Zm4.05.07c-.15 0-.3-.03-.45-.08a1.1 1.1 0 0 1-.41-.29c-.12-.13-.22-.3-.29-.52-.07-.22-.1-.48-.1-.8 0-.38.04-.7.14-.98.1-.27.25-.47.44-.61.2-.15.43-.22.7-.22.19 0 .35.03.5.1a1.02 1.02 0 0 1 .59.72v.03h-.41l-.01-.02a.67.67 0 0 0-.38-.4.77.77 0 0 0-.3-.06c-.2 0-.36.06-.49.18s-.22.28-.28.47a2.5 2.5 0 0 0-.11.7v.07l.1.56a.8.8 0 0 0 .37.68c.12.07.25.1.39.1a.73.73 0 0 0 .65-.38c.07-.11.1-.25.1-.39a.78.78 0 0 0-.1-.4.68.68 0 0 0-.26-.27.75.75 0 0 0-.39-.1.74.74 0 0 0-.76.75h-.14v-.6h.08a.93.93 0 0 1 .49-.45c.12-.04.25-.06.4-.06.22 0 .4.05.57.14.16.1.3.23.39.4.1.17.14.36.14.58a1.1 1.1 0 0 1-.57 1c-.17.1-.37.15-.6.15Z"
        />
        <g clipPath="url(#campaignTracker-l)">
          <rect
            width={65.15}
            height={6.78}
            x={246.43}
            y={53.28}
            fill={templateStyles['background']}
            rx={1.02}
          />
          <path fill={templateStyles['background']} d="M247.44 54.3h4.75v4.74h-4.75z" />
          <path
            fill={templateStyles['link']}
            d="M249.17 56.57c-.05-.05-.12-.05-.16.01l-.76 1.54-.01.04.01.05.03.03.05.01h1.07a.1.1 0 0 0 .05-.01l.03-.04c.23-.48.1-1.2-.31-1.63Zm.56-1.4c-.43.68-.4 1.43-.12 2l.52 1.03a.1.1 0 0 0 .08.05h1.12l.03-.04a.1.1 0 0 0 .01-.04.1.1 0 0 0 0-.05l-1.48-2.95c-.03-.07-.12-.07-.16 0ZM253.64 58.28v-3.35h.48l1.15 2.8h.03l1.15-2.8h.49v3.35h-.4v-2.56h-.2l.47-.7-1.35 3.26h-.35l-1.35-3.26.47.7h-.2v2.56h-.4Zm4.78.04a.98.98 0 0 1-.42-.09.73.73 0 0 1-.3-.26.7.7 0 0 1-.11-.4c0-.14.04-.27.1-.38a.7.7 0 0 1 .32-.25c.13-.06.3-.1.49-.1l.92-.06v.32l-.87.06a.76.76 0 0 0-.42.12.34.34 0 0 0-.13.29c0 .13.05.23.15.3.1.07.21.1.36.1a.8.8 0 0 0 .36-.08c.11-.06.2-.13.25-.23.07-.09.1-.2.1-.31v-.78c0-.16-.05-.28-.15-.36-.09-.08-.23-.12-.41-.12a.75.75 0 0 0-.37.08.39.39 0 0 0-.2.23h-.4v-.01a.68.68 0 0 1 .16-.34c.1-.1.2-.18.34-.23.14-.06.3-.09.48-.09.2 0 .38.04.52.1a.7.7 0 0 1 .32.3c.07.11.11.26.11.44v1.7h-.4v-.36h-.04a.85.85 0 0 1-.44.36 1 1 0 0 1-.32.05Zm1.94-.04v-2.5h.4v.37h.04a.71.71 0 0 1 .27-.3.84.84 0 0 1 .46-.12c.28 0 .5.08.64.24.15.16.23.4.23.69v1.62h-.4v-1.52c0-.23-.05-.4-.15-.5-.1-.11-.24-.17-.44-.17a.67.67 0 0 0-.34.09.59.59 0 0 0-.23.24.83.83 0 0 0-.08.38v1.48h-.4Zm3.46.04a.98.98 0 0 1-.43-.09.73.73 0 0 1-.3-.26.7.7 0 0 1-.1-.4c0-.14.03-.27.1-.38a.7.7 0 0 1 .31-.25c.14-.06.3-.1.5-.1l.91-.06v.32l-.87.06a.76.76 0 0 0-.42.12.35.35 0 0 0-.13.29c0 .13.05.23.15.3.1.07.22.1.36.1a.8.8 0 0 0 .37-.08c.1-.06.19-.13.25-.23.06-.09.09-.2.09-.31v-.78c0-.16-.05-.28-.14-.36-.1-.08-.23-.12-.42-.12a.74.74 0 0 0-.37.08.4.4 0 0 0-.2.23h-.4v-.01a.66.66 0 0 1 .17-.34c.08-.1.2-.18.34-.23.14-.06.3-.09.47-.09.2 0 .38.04.52.1.14.07.25.17.32.3.08.11.11.26.11.44v1.7h-.4v-.36h-.04a.83.83 0 0 1-.75.41Zm2.96.84c-.2 0-.38-.03-.53-.09a.86.86 0 0 1-.36-.24.7.7 0 0 1-.16-.35h.42c.03.1.1.17.2.23s.25.1.43.1a.8.8 0 0 0 .53-.16c.12-.1.19-.24.19-.43v-.5h-.04a.86.86 0 0 1-.79.43 1 1 0 0 1-.56-.16c-.15-.1-.27-.24-.36-.42a1.45 1.45 0 0 1-.12-.62c0-.24.04-.45.12-.63a1 1 0 0 1 .93-.59c.12 0 .23.02.33.06a.88.88 0 0 1 .45.4h.03v-.41h.4v2.46c0 .19-.04.35-.13.49a.87.87 0 0 1-.39.31c-.17.08-.36.12-.59.12Zm-.02-1.37c.16 0 .29-.04.4-.1a.7.7 0 0 0 .25-.3c.06-.13.1-.28.1-.44 0-.17-.04-.32-.1-.45a.7.7 0 0 0-.25-.3.7.7 0 0 0-.4-.11.7.7 0 0 0-.4.1.7.7 0 0 0-.24.31 1.1 1.1 0 0 0-.08.44c0 .17.03.32.08.44a.7.7 0 0 0 .25.3c.1.07.24.11.4.11Zm2.9.53a1.04 1.04 0 0 1-1-.6c-.1-.2-.14-.42-.14-.68 0-.26.05-.49.14-.69a1.06 1.06 0 0 1 .98-.62 1.01 1.01 0 0 1 .96.6c.09.19.13.4.13.66v.15h-2v-.32h1.8l-.2.3v-.16c0-.2-.03-.36-.1-.49a.63.63 0 0 0-.6-.38.67.67 0 0 0-.35.1.68.68 0 0 0-.25.3c-.07.12-.1.28-.1.47v.16c0 .17.03.33.1.45a.67.67 0 0 0 .65.4c.1 0 .2-.02.29-.05a.64.64 0 0 0 .2-.12c.06-.05.1-.1.12-.15v-.02h.41v.02a.75.75 0 0 1-.12.25.92.92 0 0 1-.21.21c-.09.07-.19.12-.3.16-.13.03-.26.05-.4.05Zm3.25.83a.96.96 0 0 1-.18-.01v-.33h.08l.08.01c.12 0 .21-.03.29-.09a.6.6 0 0 0 .17-.3l.05-.15-.92-2.5h.43l.77 2.3-.16-.25h.19l-.16.26.76-2.31h.43l-.98 2.65c-.06.19-.14.33-.21.44a.62.62 0 0 1-.27.22.94.94 0 0 1-.37.06Zm3.3-.83c-.24 0-.44-.05-.62-.15-.17-.1-.3-.26-.4-.45-.09-.2-.14-.42-.14-.69 0-.27.05-.5.14-.7.1-.19.23-.34.4-.44.18-.1.38-.16.62-.16s.44.06.61.16c.17.1.3.25.4.44.1.2.14.43.14.7 0 .27-.05.5-.14.69a1.04 1.04 0 0 1-1.01.6Zm0-.36a.7.7 0 0 0 .4-.1.7.7 0 0 0 .25-.33c.06-.14.09-.3.09-.5s-.03-.37-.1-.51a.68.68 0 0 0-.24-.32.7.7 0 0 0-.4-.11.7.7 0 0 0-.4.11c-.11.07-.2.18-.26.32s-.08.3-.08.5v.01c0 .2.02.36.08.5a.7.7 0 0 0 .25.32.7.7 0 0 0 .4.11Zm2.61.36a.97.97 0 0 1-.47-.1.69.69 0 0 1-.3-.32c-.06-.14-.09-.3-.09-.5v-1.62h.4v1.52c0 .22.05.39.13.5.1.1.24.16.44.16a.8.8 0 0 0 .29-.04.58.58 0 0 0 .21-.14.6.6 0 0 0 .13-.23.92.92 0 0 0 .04-.3v-1.47h.4v2.5h-.4v-.38h-.04a.68.68 0 0 1-.41.37c-.1.03-.2.05-.33.05Zm1.94-.04v-2.5h.4v.37h.04a.6.6 0 0 1 .24-.3c.12-.08.26-.12.43-.12a1.29 1.29 0 0 1 .2.02v.4a1.14 1.14 0 0 0-.25-.03.74.74 0 0 0-.34.07.6.6 0 0 0-.24.22.6.6 0 0 0-.08.32v1.55h-.4Zm4.16.04a1.05 1.05 0 0 1-1-.6c-.1-.2-.14-.42-.14-.68 0-.26.04-.49.13-.69a1.06 1.06 0 0 1 .98-.62c.24 0 .43.06.6.16.15.1.28.25.37.44.08.19.13.4.13.66v.15h-2v-.32h1.8l-.2.3v-.16c0-.2-.04-.36-.1-.49a.62.62 0 0 0-.6-.38.67.67 0 0 0-.36.1.67.67 0 0 0-.25.3c-.06.12-.09.28-.09.47v.16c0 .17.03.33.1.45a.67.67 0 0 0 .64.4c.12 0 .21-.02.3-.05a.65.65 0 0 0 .2-.12c.06-.05.1-.1.12-.15v-.02h.4v.02a.8.8 0 0 1-.11.25.94.94 0 0 1-.52.37 1.3 1.3 0 0 1-.4.05Zm1.7-.04v-2.5h.4v.38h.04a.67.67 0 0 1 .67-.43c.11 0 .21.02.3.06.1.04.17.09.24.15.06.07.11.15.15.23h.04a.8.8 0 0 1 .44-.38c.1-.04.21-.06.32-.06a.9.9 0 0 1 .43.1c.12.06.22.15.28.28.06.12.09.26.09.44v1.73h-.4v-1.64a.7.7 0 0 0-.06-.3.37.37 0 0 0-.17-.19.6.6 0 0 0-.3-.06.55.55 0 0 0-.5.29.59.59 0 0 0-.07.29v1.6h-.4v-1.69a.5.5 0 0 0-.07-.26.43.43 0 0 0-.18-.17.59.59 0 0 0-.57.03.61.61 0 0 0-.2.23.7.7 0 0 0-.08.32v1.55h-.4Zm4.81.04a.98.98 0 0 1-.42-.09.73.73 0 0 1-.3-.26.7.7 0 0 1-.11-.4c0-.14.03-.27.1-.38a.7.7 0 0 1 .32-.25c.13-.06.3-.1.49-.1l.92-.06v.32l-.87.06a.76.76 0 0 0-.42.12.34.34 0 0 0-.13.29c0 .13.05.23.15.3.1.07.21.1.36.1a.8.8 0 0 0 .36-.08c.11-.06.2-.13.25-.23.07-.09.1-.2.1-.31v-.78c0-.16-.05-.28-.15-.36-.09-.08-.23-.12-.41-.12a.75.75 0 0 0-.37.08.39.39 0 0 0-.2.23h-.4v-.01a.68.68 0 0 1 .16-.34c.1-.1.2-.18.34-.23.14-.06.3-.09.48-.09.2 0 .38.04.52.1a.7.7 0 0 1 .32.3c.07.11.11.26.11.44v1.7h-.4v-.36h-.04a.85.85 0 0 1-.44.36 1 1 0 0 1-.32.05Zm1.95-.04v-2.5h.4v2.5h-.4Zm.2-2.98a.27.27 0 0 1-.2-.09.27.27 0 0 1-.08-.2.27.27 0 0 1 .28-.28c.08 0 .14.04.2.09.05.05.08.12.08.2 0 .07-.03.14-.08.2a.27.27 0 0 1-.2.08Zm.98 2.98v-3.5h.4v3.5h-.4Zm2.52 0v-2.5h.4v.38h.04a.67.67 0 0 1 .67-.43c.12 0 .22.02.3.06.1.04.17.09.24.15.06.07.12.15.15.23h.04a.8.8 0 0 1 .44-.38c.1-.04.21-.06.33-.06a.9.9 0 0 1 .43.1c.12.06.2.15.27.28.06.12.1.26.1.44v1.73h-.41v-1.64a.7.7 0 0 0-.06-.3.37.37 0 0 0-.17-.19.61.61 0 0 0-.3-.06.55.55 0 0 0-.5.29.59.59 0 0 0-.07.29v1.6h-.4v-1.69a.5.5 0 0 0-.07-.26.42.42 0 0 0-.18-.17.59.59 0 0 0-.27-.06c-.11 0-.21.03-.3.09a.61.61 0 0 0-.2.23.7.7 0 0 0-.08.32v1.55h-.4Zm4.82.04a.98.98 0 0 1-.43-.09.74.74 0 0 1-.3-.26.71.71 0 0 1-.1-.4c0-.14.03-.27.1-.38a.7.7 0 0 1 .3-.25c.14-.06.3-.1.5-.1l.92-.06v.32l-.87.06a.76.76 0 0 0-.42.12.34.34 0 0 0-.13.29c0 .13.05.23.15.3.1.07.21.1.36.1a.8.8 0 0 0 .37-.08c.1-.06.19-.13.25-.23.06-.09.09-.2.09-.31v-.78c0-.16-.05-.28-.14-.36-.1-.08-.24-.12-.42-.12a.75.75 0 0 0-.37.08.4.4 0 0 0-.2.23h-.4v-.01a.67.67 0 0 1 .17-.34c.08-.1.2-.18.34-.23.14-.06.3-.09.47-.09.2 0 .38.04.52.1a.7.7 0 0 1 .32.3c.08.11.11.26.11.44v1.7h-.4v-.36h-.04a.85.85 0 0 1-.44.36 1 1 0 0 1-.31.05Zm1.93-.04v-2.5h.4v.37h.04a.6.6 0 0 1 .24-.3c.12-.08.26-.12.43-.12a1.29 1.29 0 0 1 .2.02v.4a1.2 1.2 0 0 0-.25-.03.74.74 0 0 0-.34.07.59.59 0 0 0-.23.22.6.6 0 0 0-.09.32v1.55h-.4Zm2.14.02a.3.3 0 0 1-.22-.09.3.3 0 0 1-.08-.21c0-.08.03-.16.08-.21a.3.3 0 0 1 .22-.1c.08 0 .15.04.21.1.06.05.09.13.09.2a.3.3 0 0 1-.09.22.29.29 0 0 1-.21.09Zm1.2 0a.3.3 0 0 1-.3-.3.3.3 0 0 1 .3-.3.3.3 0 0 1 .22.09c.06.05.09.13.09.2a.3.3 0 0 1-.1.22.3.3 0 0 1-.2.09Zm1.2 0a.3.3 0 0 1-.2-.09.3.3 0 0 1-.1-.21c0-.08.04-.16.1-.21a.3.3 0 0 1 .2-.1.3.3 0 0 1 .22.1c.06.05.1.13.1.2a.3.3 0 0 1-.1.22.3.3 0 0 1-.21.09Z"
          />
        </g>
        <rect
          width={65.15}
          height={6.78}
          x={246.43}
          y={53.28}
          stroke={templateStyles['border']}
          strokeWidth={0.34}
          rx={1.02}
        />
      </g>
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M266.43 74.23v2.12h.5v-2.12h2.12v-.5h-2.12V71.6h-.5v2.12h-2.13v.5h2.13Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontFamily']}
        fontSize={4.75}
        fontWeight={510}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={271.03} y={75.56}>
          {formatMessage(messages['templates-preview.add-entry'])}
        </tspan>
      </text>
      <path
        fill={templateStyles['boardBackground']}
        d="M320 5.02c0-.56.46-1.02 1.02-1.02h11.53c.56 0 1.02.46 1.02 1.02v11.2c0 .55-.46 1-1.02 1h-11.53c-.56 0-1.02-.45-1.02-1V5.01Z"
      />
      <path
        fill={templateStyles['background']}
        fillOpacity={0.01}
        d="M322.71 6.54h8.14v8.14h-8.14z"
      />
      <path
        fill={templateStyles['fontColor']}
        d="M326.78 7.9c.18 0 .32.13.34.3v2.08h2.04a.34.34 0 0 1 .04.67h-2.08V13a.34.34 0 0 1-.67.04v-2.08h-2.04a.34.34 0 0 1-.04-.67h2.07V8.24c0-.19.16-.34.34-.34Z"
      />
      <defs>
        <clipPath id="campaignTracker-a">
          <rect
            width={76}
            height={134.18}
            x={4}
            y={4}
            fill={templateStyles['background']}
            rx={1.02}
          />
        </clipPath>
        <clipPath id="campaignTracker-c">
          <rect
            width={65.15}
            height={6.78}
            x={9.43}
            y={60.28}
            fill={templateStyles['background']}
            rx={1.02}
          />
        </clipPath>
        <clipPath id="campaignTracker-e">
          <rect
            width={65.15}
            height={6.78}
            x={9.43}
            y={108.2}
            fill={templateStyles['background']}
            rx={1.02}
          />
        </clipPath>
        <clipPath id="campaignTracker-f">
          <path fill={templateStyles['background']} d="M10.44 109.22h4.75v4.75h-4.75z" />
        </clipPath>
        <clipPath id="campaignTracker-h">
          <rect
            width={65.15}
            height={6.78}
            x={88.43}
            y={53.28}
            fill={templateStyles['background']}
            rx={1.02}
          />
        </clipPath>
        <clipPath id="campaignTracker-j">
          <rect
            width={65.15}
            height={6.78}
            x={167.43}
            y={60.28}
            fill={templateStyles['background']}
            rx={1.02}
          />
        </clipPath>
        <clipPath id="campaignTracker-l">
          <rect
            width={65.15}
            height={6.78}
            x={246.43}
            y={53.28}
            fill={templateStyles['background']}
            rx={1.02}
          />
        </clipPath>
        <filter
          id="campaignTracker-b"
          width={71.39}
          height={53.44}
          x={6.3}
          y={18.51}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.41} />
          <feGaussianBlur stdDeviation={0.21} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_15314" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.21} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_15314"
            result="effect2_dropShadow_1228_15314"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_15314"
            result="shape"
          />
        </filter>
        <filter
          id="campaignTracker-d"
          width={71.39}
          height={46.44}
          x={6.3}
          y={73.43}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.41} />
          <feGaussianBlur stdDeviation={0.21} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_15314" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.21} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_15314"
            result="effect2_dropShadow_1228_15314"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_15314"
            result="shape"
          />
        </filter>
        <filter
          id="campaignTracker-g"
          width={71.39}
          height={46.44}
          x={85.3}
          y={18.51}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.41} />
          <feGaussianBlur stdDeviation={0.21} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_15314" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.21} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_15314"
            result="effect2_dropShadow_1228_15314"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_15314"
            result="shape"
          />
        </filter>
        <filter
          id="campaignTracker-i"
          width={71.39}
          height={53.44}
          x={164.3}
          y={18.51}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.41} />
          <feGaussianBlur stdDeviation={0.21} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_15314" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.21} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_15314"
            result="effect2_dropShadow_1228_15314"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_15314"
            result="shape"
          />
        </filter>
        <filter
          id="campaignTracker-k"
          width={71.39}
          height={46.44}
          x={243.3}
          y={18.51}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.41} />
          <feGaussianBlur stdDeviation={0.21} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_15314" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.21} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_15314"
            result="effect2_dropShadow_1228_15314"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_15314"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export default CampaignTracker;
